import { IconButton } from "@material-ui/core";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import ButtonSml from "../../../../../common_components/buttonsml";
import CustomIcons from "../../../../../common_components/commonIcons";
import BlockingLoader from "../../../../../common_components/loader/blockingloader";
import SearchSelectBox from "../../../../../common_components/searchSelectBox/searchSelectBox";
import SnackComp from "../../../../../common_components/snackbar/snack.component";
import {
  DynFormValidate,
  FormatError,
} from "../../../../../utils/formValidate";
import {
  accountSearch,
  contactSearch,
  fetchConvertFields,
  fetchConvertFieldsCreate,
  leadConvert,
  opportunitySearch,
} from "../../api.functions";
import LeadConvertCreate from "./leadconvertcreate";
import LeadConvertEmpty from "./leadconvertempty";
import LeadConvertSelect from "./leadconvertselect";

export default class LeadConvert extends React.Component {
  constructor(props) {
    super(props);

    const { mappingData, propsLeadData } = this.prepareLeadData(props.leadData);

    this.state = {
      open: props.open,
      leadData: propsLeadData,
      Accounts: [],

      // leadData: {
      //   account: [],
      //   contact: [],
      //   opportunity: [],
      // },
      fieldData: {
        account: [],
        contact: [],
        opportunity: [],
      },
      originalLeadData: {
        account: [],
        contact: [],
        opportunity: [],
      },
      OriginalFieldData: {
        account: [],
        contact: [],
        opportunity: [],
      },
      mappingData: mappingData,
      activeItem: props.convertType,
      snackData: { open: false, message: "", variant: "" },
      accountCreate: false,
      contactCreate: false,
      opportunityCreate: false,

      isActive: false,
      AccountDatas: {},
      Contacts: [],
      ContactDatas: {},
      Opertunities: [],
      OpportunityDatas: {},
      errors: {},
    };

    this.child = React.createRef();
  }
  componentDidMount = () => {
    this.getCreatefields();
  };
  componentWillReceiveProps = (props) => {
    this.setState({
      isActive: true,
    });

    const { mappingData, propsLeadData } = this.prepareLeadData(props.leadData);
    this.setState({
      open: props.open,
      activeItem: props.convertType,
      leadData: propsLeadData,
      mappingData: mappingData,
      isActive: false,
    });
  };

  prepareLeadData = (leadData) => {
    let mappingData = {
      account: {},
      contact: {},
      opportunity: {},
    };
    let propsLeadData = {};
    //
    Object.keys(leadData).map((key, index) => {
      // const fieldName = props.leadData[key]
      //

      propsLeadData[key] = leadData[key].map((data) => {
        //

        data["attributes"]["api_id"] = data["value"]["api_id"];
        data["attributes"]["api_value"] = data["value"]["api_value"];
        data["attributes"]["options"] = data["value"]["options"];
        mappingData[key][data["lead_field_name"]] = data;
        return data;
      });
    });
    //
    //
    let returnData = {
      mappingData: mappingData,
      propsLeadData: propsLeadData,
    };
    return returnData;
  };

  handleClose = () => {
    this.setState({
      Accounts: [],
      activeItem: "",
      AccountDatas: {},
      Contacts: [],
      ContactDatas: {},
      Opertunities: [],
      OpportunityDatas: {},
      leadData: {},
      fieldData: {},
      errors: {},
      originalLeadData: {},
      OriginalFieldData: {},
    });
    this.props.handleClose();
  };

  getCreatefields = () => {
    //
    let id = this.props.leadId;
    this.setState({
      isActive: true,
    });
    fetchConvertFieldsCreate()
      .then((res) => res.data)
      .then((res) => {
        let accountFields = res.account;

        accountFields.forEach((item) => {
          item["selected"] = true;
          //
          //
          item["value_attributes"] =
            this.state.mappingData["account"][item["lead_field_name"]];
          item["attribute"]["api_value"] = this.state.mappingData["account"][
            item["lead_field_name"]
          ]
            ? this.state.mappingData["account"][item["lead_field_name"]][
            "value"
            ]["api_value"]
            : null;

          item["attribute"]["api_id"] = this.state.mappingData["account"][
            item["lead_field_name"]
          ]
            ? this.state.mappingData["account"][item["lead_field_name"]][
            "value"
            ]["api_id"]
            : null;

          if (item["attribute"]["attribute_type_slug"] == "multi_select" || item["attribute"]["attribute_type_slug"] == "search_multi_select") {
            item["attribute"]["options"] = this.state.mappingData["account"][
              item["lead_field_name"]
            ]
              ? this.state.mappingData["account"][item["lead_field_name"]][
              "value"
              ]["options"]
              : null;
          }

          //
        });

        let contactFields = res.contact;
        contactFields.forEach((item) => {
          item["selected"] = true;
          item["value_attributes"] =
            this.state.mappingData["contact"][item["lead_field_name"]];
          item["attribute"]["api_value"] = this.state.mappingData["contact"][
            item["lead_field_name"]
          ]
            ? this.state.mappingData["contact"][item["lead_field_name"]][
            "value"
            ]["api_value"]
            : null;
          item["attribute"]["api_id"] = this.state.mappingData["contact"][
            item["lead_field_name"]
          ]
            ? this.state.mappingData["contact"][item["lead_field_name"]][
            "value"
            ]["api_id"]
            : null;
          if (item["attribute"]["attribute_type_slug"] == "multi_select" || item["attribute"]["attribute_type_slug"] == "search_multi_select") {
            item["attribute"]["options"] = this.state.mappingData["contact"][
              item["lead_field_name"]
            ]
              ? this.state.mappingData["contact"][item["lead_field_name"]][
              "value"
              ]["options"]
              : null;
          }
          // mappingData['contact'][item.lead_field_name] = item;
        });

        let opportunityFields = res.opportunity;
        opportunityFields.forEach((item) => {
          item["selected"] = true;
          item["value_attributes"] =
            this.state.mappingData["opportunity"][item["lead_field_name"]];
          item["attribute"]["api_value"] = this.state.mappingData[
            "opportunity"
          ][item["lead_field_name"]]
            ? this.state.mappingData["opportunity"][item["lead_field_name"]][
            "value"
            ]["api_value"]
            : null;
          item["attribute"]["api_id"] = this.state.mappingData["opportunity"][
            item["lead_field_name"]
          ]
            ? this.state.mappingData["opportunity"][item["lead_field_name"]][
            "value"
            ]["api_id"]
            : null;

          if (item["attribute"]["attribute_type_slug"] == "multi_select" || item["attribute"]["attribute_type_slug"] == "search_multi_select") {
            item["attribute"]["options"] = this.state.mappingData[
              "opportunity"
            ][item["lead_field_name"]]
              ? this.state.mappingData["opportunity"][item["lead_field_name"]][
              "value"
              ]["options"]
              : null;
          }
          // mappingData['opportunity'][item.lead_field_name] = item;
        });
        //
        //

        this.setState({
          // mappingData: mappingData,
          isActive: false,
          fieldData: {
            ...this.state.fieldData,

            account: accountFields,
            contact: contactFields,
            opportunity: opportunityFields,
          },
          originalFieldData: {
            ...this.state.originalFieldData,

            account: accountFields,
            contact: contactFields,
            opportunity: opportunityFields,
          },
        });
      })

      .catch((err) => {
        this.setState({
          submit: false,

          isActive: false,
          snackData: {
            open: true,

            variant: "error",
            message: err.response?.data?.error ?? "",
          },
        });
      });
  };

  fetchData = (e) => {
    const childRef = this.child.current;
    childRef.fetchSubmitData();
  };

  resetFieldData(key) {
    this.state.fieldData[key].forEach((item) => {
      item["selected"] = false;
    });
  }
  resetLeadData(key) {
    const { leadData } = this.state;
    //
    leadData[key].forEach((item) => {
      item["selected"] = false;
    });
    this.setState({
      leadData: leadData,
    });
  }

  fetchValuesFromChild = (field, lead) => {
    this.setState({ submit: true });
    let accountData = [];
    let contactData = [];
    let opertunityData = [];

    let accountErrors = [];
    let contactErrors = [];
    let opertunityError = [];

    let accountFlag = false;
    let opertunityFlag = false;
    let contactFlag = false;

    //

    //////////////////////////////////////////////////
    field["account"].forEach((item) => {
      if (item.selected) {
        let attribute = item.attribute;
        if (attribute) {
          let data = item["data"];
          //
          //
          attribute["api_value"] =
            data && data["api_value"]
              ? data["api_value"]
              : attribute["api_value"];
          attribute["api_id"] =
            data && data["api_value"] ? data["api_id"] : attribute["api_id"];
          //
          accountData.push(attribute);
        }
      }
    });
    lead["account"].forEach((item) => {
      if (item.selected) {
        let validation_items = field["account"].filter((field_item) => {
          return field_item.model_field_name === item["model_field_name"];
        });

        item.attributes["is_mandatory"] =
          validation_items.length > 0
            ? validation_items[0].attribute["is_mandatory"]
            : item.attributes["is_mandatory"];
        item.attributes["api_name"] = item["model_field_name"];
        accountData.push(item.attributes);
      }
    });

    //////////////////////////////////////////////////
    field["contact"].forEach((item) => {
      if (item.selected) {
        let attribute = item.attribute;
        if (attribute) {
          let data = item["data"];
          attribute["api_value"] =
            data && data["api_value"]
              ? data["api_value"]
              : attribute["api_value"];
          attribute["api_id"] =
            data && data["api_value"] ? data["api_id"] : attribute["api_id"];
          //
          contactData.push(attribute);
        }
      }
    });
    lead["contact"].forEach((item) => {
      if (item.selected) {
        //
        let validation_items = field["contact"].filter((field_item) => {
          return field_item.model_field_name === item["model_field_name"];
        });
        item.attributes["is_mandatory"] =
          validation_items.length > 0
            ? validation_items[0].attribute["is_mandatory"]
            : item.attributes["is_mandatory"];

        item.attributes["api_name"] = item["model_field_name"];
        contactData.push(item.attributes);
      }
    });

    //////////////////////////////////////////////////
    field["opportunity"].forEach((item) => {
      if (item.selected) {
        let attribute = item.attribute;
        if (attribute) {
          let data = item["data"];
          attribute["api_value"] =
            data && data["api_value"]
              ? data["api_value"]
              : attribute["api_value"];
          attribute["api_id"] =
            data && data["api_value"] ? data["api_id"] : attribute["api_id"];
          opertunityData.push(attribute);
        }
      }
    });
    lead["opportunity"].forEach((item) => {
      if (item.selected) {
        let validation_items = field["opportunity"].filter((field_item) => {
          return field_item.model_field_name === item["model_field_name"];
        });
        item.attributes["is_mandatory"] =
          validation_items.length > 0
            ? validation_items[0].attribute["is_mandatory"]
            : item.attributes["is_mandatory"];
        item.attributes["api_name"] = item["model_field_name"];
        opertunityData.push(item.attributes);
      }
    });
    //////////////////////////////////////////////////

    //
    //
    //

    accountErrors = DynFormValidate(accountData);

    const accountErrorMessages = [];
    const contactErrorMessages = [];
    const opportunityErrorMessages = [];

    accountErrors.forEach((item) => {
      if (item.error) {
        //
        accountFlag = true;
        if (item["error_message"] && item["error_message"].length > 0) {
          accountErrorMessages.push(item["error_message"]);
        }
      }
    });

    //////////////////////////////////////////////////
    contactErrors = DynFormValidate(contactData);
    contactErrors.forEach((item) => {
      if (item.error) {
        //
        contactFlag = true;
        if (item["error_message"] && item["error_message"].length > 0) {
          contactErrorMessages.push(item["error_message"]);
        }
      }
    });

    //////////////////////////////////////////////////
    opertunityError = DynFormValidate(opertunityData);
    opertunityError.forEach((item) => {
      if (item.error) {
        //
        opertunityFlag = true;
        if (item["error_message"] && item["error_message"].length > 0) {
          opportunityErrorMessages.push(item["error_message"]);
        }
      }
    });

    //////////////////////////////////////////////////
    if (!accountFlag) {
      let finalAccountData = {};

      accountErrors.forEach((item) => {
        finalAccountData = {
          ...finalAccountData,
          [item.api_name]: item.api_id ? item.api_id : item.api_value ?? null,
        };
      });

      //////////////////////////////////////////////////
      if (!contactFlag) {
        let finalContactData = {};
        //
        contactErrors.forEach((item) => {
          finalContactData = {
            ...finalContactData,
            [item.api_name]: item.api_id ? item.api_id : item.api_value ?? null,
          };
        });
        //////////////////////////////////////////////////

        if (!opertunityFlag) {
          let finalOpertunityData = {};
          //
          opertunityError.forEach((item) => {
            finalOpertunityData = {
              ...finalOpertunityData,
              [item.api_name]: item.api_id
                ? item.api_id
                : item.api_value ?? null,
            };
          });

          //////////////////////////////////////////////////
          setTimeout(() => {
            this.handleSubmit(
              finalAccountData,
              finalContactData,
              finalOpertunityData
            );
          }, 250);
          //////////////////////////////////////////////////
        } else {
          this.setState({
            submit: false,
            activeItem: "opportunity",
            opportunityCreate: true,
            snackData: {
              open: true,

              variant: "error",
              message:
                opportunityErrorMessages.length > 0
                  ? opportunityErrorMessages.join(", ")
                  : "Please fill all required fields in Opportunity",
            },
          });
        } //////////////////////////////////////////////////
      } else {
        this.setState({
          submit: false,
          activeItem: "contact",
          contactCreate: true,
          snackData: {
            open: true,

            variant: "error",
            message:
              contactErrorMessages.length > 0
                ? contactErrorMessages.join(", ")
                : "Please fill all required fields in Contact",
          },
        });
      } //////////////////////////////////////////////////
    } else {
      this.setState({
        submit: false,
        activeItem: "account",
        accountCreate: true,
        snackData: {
          open: true,

          variant: "error",
          message:
            accountErrorMessages.length > 0
              ? accountErrorMessages.join(", ")
              : "Please fill all required fields in Account",
        },
      });
    } //////////////////////////////////////////////////
  };

  handleSubmit = (acnt, cont, oper) => {
    const { OpportunityDatas, AccountDatas, ContactDatas } = this.state;

    let Opportunity = oper;
    let Contact = cont;
    let Account = acnt;
    let formData = {};

    if (
      OpportunityDatas.OpportunityId !== "" &&
      OpportunityDatas.OpportunityId !== null &&
      OpportunityDatas.OpportunityId !== undefined
    ) {
      Opportunity = {
        ...Opportunity,
        entity_id: OpportunityDatas.OpportunityId,
      };
    }

    if (
      ContactDatas.ContactId !== "" &&
      ContactDatas.ContactId !== null &&
      ContactDatas.ContactId !== undefined
    ) {
      Contact = {
        ...Contact,
        entity_id: ContactDatas.ContactId,
      };
    }

    if (
      AccountDatas.AccountId !== "" &&
      AccountDatas.AccountId !== null &&
      AccountDatas.AccountId !== undefined
    ) {
      Account = {
        ...Account,
        entity_id: AccountDatas.AccountId,
      };
    }

    formData = {
      lead_id: this.props.leadId,
      entity: {
        account: Account,
        opportunity: Opportunity,
        contact: Contact,
      },
    };

    //
    this.setState({ isActive: true, submit: true });
    leadConvert(formData)
      .then((res) => res.data)
      .then((res) => {
        this.setState(
          {
            submit: false,

            isActive: false,

            snackData: {
              open: true,

              variant: "success",
              message: res.message,
            },
          },
          () => this.props.handleRefresh()
        );
      })

      .catch((err) => {
        var errorString = FormatError(err);
        this.setState({
          submit: false,
          snackData: {
            open: true,

            variant: "error",
            message:
              errorString ?? "Could not convert lead. Please try again later",
          },

          isActive: false,
        });
      });
  };

  fetchItemFields = (key, idlabel, id) => {
    if (id) {
      const { fieldData } = this.state;
      this.setState({
        isActive: true,
      });
      fetchConvertFields(key, idlabel, id)
        .then((res) => res.data)
        .then((res) => {
          if (key === "account") {
            let accountFields = res.account;
            this.resetLeadData("account");
            accountFields.forEach((item) => {
              item["selected"] = true;
              // item["attribute"] = item.data;
            });
            this.setState({
              isActive: false,

              fieldData: {
                ...this.state.fieldData,

                account: accountFields,
              },
              // originalFieldData: {
              //   ...this.state.originalFieldData,
              //   account: accountFields
              // }
            });
          } else if (key === "contact") {
            let contactFields = res.contact;
            this.resetLeadData("contact");

            contactFields.forEach((item) => {
              item["selected"] = true;
              // item["attribute"] = item.data;
            });
            this.setState({
              isActive: false,

              fieldData: {
                ...this.state.fieldData,

                contact: contactFields,
              },
            });
          } else if (key === "opportunity") {
            let opportunityFields = res.opportunity;
            this.resetLeadData("opportunity");

            opportunityFields.forEach((item) => {
              item["selected"] = true;
              // item["attribute"] = item.data;
            });
            this.setState({
              isActive: false,

              fieldData: {
                ...this.state.fieldData,

                opportunity: opportunityFields,
              },
            });
          }
        })

        .catch((err) => {
          this.setState({
            submit: false,

            isActive: false,
            snackData: {
              open: true,

              variant: "error",
              message: err?.response?.data?.error ?? "Could not fetch data",
            },
          });
        });
    }
  };

  fetchAccounts = (value) => {
    let data = {
      keyword: value ?? "",
      OpportunityId: this.state.OpportunityDatas.OpportunityId ?? "",
      ContactId: this.state.ContactDatas.ContactId ?? "",
    };
    accountSearch(data)
      .then((res) => res.data)
      .then((res) => {
        this.setState({
          OriginalAccounts: res.account,
          Accounts: res.account,
        });
      })

      .catch((err) => {
        this.setState({
          submit: false,

          isActive: false,
          snackData: {
            open: true,

            variant: "error",
            message: err?.response?.data?.error ?? "",
          },
        });
      });
  };

  handleAccountAutoChange = (e) => {
    this.setState(
      {
        AccountDatas: {
          ...this.state.AccountDatas,
          AccountId: e.id,
          AccountName: e.name,
        },
        ContactDatas: {
          ...this.state.ContactDatas,
          ContactId: "",
          ContactName: "",
        },
        OpportunityDatas: {
          ...this.state.OpportunityDatas,
          OpportunityId: "",
          OpportunityName: "",
        },
        accountCreate: false,
      },
      () => this.fetchItemFields("account", "account_id", e.id)
    );
  };

  fetchContacts = (value) => {
    let data = {
      keyword: value ?? "",
      OpportunityId: this.state.OpportunityDatas.OpportunityId ?? "",
      AccountId: this.state.AccountDatas.AccountId ?? "",
    };
    contactSearch(data)
      .then((res) => res.data)
      .then((res) => {
        let dat = res.contact;
        dat.forEach((item) => {
          item["name"] =
            item.first_name +
            (item.last_name && item.last_name.length > 0
              ? " " + item.last_name
              : "");
        });

        this.setState({
          Contacts: dat,
        });
      })

      .catch((err) => {
        this.setState({
          submit: false,
          snackData: {
            open: true,

            variant: "error",
            message: err.response.data.error,
          },
          isActive: false,
        });
      });
  };

  toggleActiveItem = (item) => {
    this.setState({ activeItem: item });
  };

  handleContactAutoChange = (e) => {
    this.setState(
      {
        ContactDatas: {
          ...this.state.ContactDatas,
          ContactId: e.id,
          ContactName: e.name,
        },
        OpportunityDatas: {
          ...this.state.OpportunityDatas,
          OpportunityId: "",
          OpportunityName: "",
        },
        contactCreate: false,
      },
      () => this.fetchItemFields("contact", "contact_id", e.id)
    );
  };

  fetchOpportunity = (value) => {
    let data = {
      keyword: value ?? "",
      AccountId: this.state.AccountDatas.AccountId ?? "",
      ContactId: this.state.ContactDatas.ContactId ?? "",
    };
    opportunitySearch(data)
      .then((res) => res.data)
      .then((res) => {
        this.setState({
          Opertunities: res.opportunity,
        });
      })

      .catch((err) => {
        this.setState({
          submit: false,

          isActive: false,
          snackData: {
            open: true,

            variant: "error",
            message: err.response.data.error,
          },
        });
      });
  };

  handleOpportunityAutoChange = (e) => {
    this.setState(
      {
        OpportunityDatas: {
          ...this.state.OpportunityDatas,
          OpportunityId: e.id,
          OpportunityName: e.name,
        },
        opportunityCreate: false,
      },
      () => this.fetchItemFields("opportunity", "opportunity_id", e.id)
    );
  };

  handleCreateAccount = () => {
    //
    this.setState({
      fieldData: {
        ...this.state.fieldData,
        account: this.state.originalFieldData["account"],
      },
      AccountDatas: {
        // ...this.state.OriginalAccounts,
        ...this.state.AccountDatas,
        AccountId: "",
        AccountName: "",
      },
      activeItem: "account",
      accountCreate: true,
    });
  };

  handleCreateContact = () => {
    this.setState({
      fieldData: {
        ...this.state.fieldData,
        contact: this.state.originalFieldData["contact"],
      },
      ContactDatas: {
        ...this.state.ContactDatas,
        ContactId: "",
        ContactName: "",
      },
      activeItem: "contact",

      contactCreate: true,
    });
  };

  handleCreateOpportunity = () => {
    this.setState({
      fieldData: {
        ...this.state.fieldData,
        opportunity: this.state.originalFieldData["opportunity"],
      },
      OpportunityDatas: {
        ...this.state.OpportunityDatas,
        OpportunityId: "",
        OpportunityName: "",
      },
      activeItem: "opportunity",

      opportunityCreate: true,
    });
  };

  onSnackclose = () => {
    this.setState({ snackData: { open: false } });
  };
  manageSubmit = (value) => {
    this.setState({ submit: value });
  };
  render() {
    const {
      open,
      Accounts,
      ContactDatas,
      Contacts,
      OpportunityDatas,
      accountCreate,
      opportunityCreate,
      contactCreate,
      Opertunities,
      activeItem,
      AccountDatas,

      errors,
    } = this.state;

    return (
      <>
        <SnackComp
          snackData={this.state.snackData}
          handleClose={this.onSnackclose}
        />

        <Dialog
          className="convert-modal"
          open={open}
        // onClose={this.handleClose}
        >
          <DialogTitle>
            {" "}
            <div className="row">
              <div className="col-12 p-0">
                <p className="m-0">Convert Lead</p>
              </div>
              <div className="col-2 pr-0">
                <IconButton
                  className="closeButtonStyle"
                  onClick={this.handleClose}
                >
                  <CustomIcons iconName="close" />
                </IconButton>
              </div>
            </div>{" "}
          </DialogTitle>

          <DialogContent>
            {this.state.isActive && (
              <div className="page_overlay">
                <BlockingLoader isActive={this.state.isActive}></BlockingLoader>
              </div>
            )}
            <div className="convertpopup-content">
              <div className="convert-list">
                <div
                  onClick={(e) => this.toggleActiveItem("account")}
                  className={
                    activeItem === "account"
                      ? `${this.props.classes.groupActive} item active`
                      : "item"
                  }
                >
                  <div className="flex-details">
                    <div className="name">
                      <span className="icon">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M4.60194 0.972376C1.14603 2.06124 1.25031 2.02204 1.13766 2.27379C1.10044 2.35695 1.09375 3.31997 1.09375 8.58646V14.801H0.546875H0V15.4005V16H8H16V15.4005V14.801H12.2656H8.53125V9.93256V5.06408H11.2031H13.875V8.35212V11.6402H14.3906H14.9062V7.973C14.9062 5.92202 14.894 4.26841 14.8785 4.22089C14.8315 4.07741 14.655 3.90545 14.5235 3.87519C14.2021 3.80122 7.82175 3.87922 7.73078 3.95821C7.49353 4.16417 7.51663 3.58919 7.5075 9.5174L7.49937 14.801H4.81219H2.125V8.90437V3.00769L4.80469 2.17028L7.48438 1.33286L7.49288 1.99952L7.50138 2.66617H8.01631H8.53125V1.53628C8.53125 -0.434688 8.89984 -0.381788 4.60194 0.972376ZM3.57628 3.91207C3.56778 3.9379 3.56469 4.21173 3.56947 4.52063L3.57812 5.08225L4.80469 5.09177L6.03125 5.10125V4.48321V3.86513H4.81153C3.84341 3.86513 3.58859 3.87483 3.57628 3.91207ZM3.58334 6.61426C3.57188 6.62755 3.5625 6.89732 3.5625 7.21373V7.78898H4.79688H6.03125V7.1895V6.59002H4.81772C4.15025 6.59002 3.59478 6.60092 3.58334 6.61426ZM9.96875 7.18906V7.78898H11.2039H12.4391L12.4305 7.19858L12.4219 6.60819L11.1953 6.59867L9.96875 6.58919V7.18906ZM3.56953 9.90531L3.57812 10.4957L4.80469 10.5052L6.03125 10.5147V9.91483V9.31492H4.79609H3.56094L3.56953 9.90531ZM9.96875 9.91483V10.5147L11.1953 10.5052L12.4219 10.4957L12.4305 9.90531L12.4391 9.31492H11.2039H9.96875V9.91483ZM3.57628 12.0504C3.56778 12.0763 3.56469 12.3501 3.56947 12.659L3.57812 13.2206L4.80469 13.2301L6.03125 13.2396V12.6216V12.0035H4.81153C3.84341 12.0035 3.58859 12.0132 3.57628 12.0504ZM9.96875 12.6211V13.2396L11.1953 13.2301L12.4219 13.2206V12.6211V12.0217L11.1953 12.0121L9.96875 12.0026V12.6211ZM13.875 13.2569V13.8201H14.3906H14.9062V13.2569V12.6938H14.3906H13.875V13.2569Z"
                            fill="#222222"
                          />
                        </svg>
                      </span>
                      <span className="text">Account</span>
                    </div>
                    <a
                      onClick={(e) => this.handleCreateAccount("account")}
                      className={`${this.props.classes.tabButton} link convert-link`}
                    >
                      <CustomIcons iconName="add" /> Create
                    </a>
                  </div>
                  <div className="fieldblock">
                    <SearchSelectBox
                      {...this.props}
                      id="select-pagesize"
                      required
                      // async={true}
                      // readOnly
                      name="AccountId"
                      placeholder="Search and select an existing Account"
                      fullWidth
                      getData={this.fetchAccounts.bind(this)}
                      value={
                        AccountDatas.AccountName ? AccountDatas.AccountName : ""
                      }
                      onChange={this.handleAccountAutoChange}
                      error={
                        errors.AccountId !== "" &&
                        errors.AccountId !== undefined
                      }
                      margin="normal"
                      Data={Accounts}
                    />
                  </div>
                </div>
                <div
                  onClick={(e) => this.toggleActiveItem("contact")}
                  className={
                    activeItem === "contact"
                      ? `${this.props.classes.groupActive} item active`
                      : "item"
                  }
                >
                  <div className="flex-details">
                    <div className="name">
                      <span className="icon">
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="1.30402"
                            y="1.34741"
                            width="11.6286"
                            height="10.935"
                            rx="0.5"
                            stroke="#222222"
                          />
                          <path
                            d="M7.10145 3.39087C7.37759 3.39087 7.60145 3.16701 7.60145 2.89087C7.60145 2.61473 7.37759 2.39087 7.10145 2.39087V3.39087ZM7.10146 7.37265C7.3776 7.37264 7.60145 7.14878 7.60145 6.87264C7.60145 6.5965 7.37759 6.37264 7.10145 6.37265L7.10146 7.37265ZM7.13522 2.39087C6.85908 2.39087 6.63522 2.61473 6.63522 2.89087C6.63522 3.16701 6.85908 3.39087 7.13522 3.39087V2.39087ZM7.13522 6.37265C6.85908 6.37264 6.63522 6.5965 6.63522 6.87264C6.63522 7.14878 6.85907 7.37264 7.13521 7.37265L7.13522 6.37265ZM6.02949 7.77942C6.27253 7.64833 6.36329 7.34504 6.2322 7.102C6.10111 6.85895 5.79781 6.7682 5.55477 6.89929L6.02949 7.77942ZM4.10298 8.05735L4.26355 8.53086H4.26355L4.10298 8.05735ZM3.50353 9.91144L3.00677 9.96822L3.03539 10.2186L3.25371 10.3446L3.50353 9.91144ZM8.68193 6.89929C8.43889 6.7682 8.13559 6.85895 8.0045 7.102C7.87341 7.34504 7.96416 7.64833 8.20721 7.77942L8.68193 6.89929ZM10.1337 8.05735L9.97315 8.53086L10.1337 8.05735ZM10.7332 9.91144L10.983 10.3446L11.2013 10.2186L11.2299 9.96822L10.7332 9.91144ZM7.10145 2.39087C6.73149 2.39087 6.18845 2.47707 5.73149 2.86505C5.25827 3.26685 4.96316 3.91826 4.96316 4.87098H5.96316C5.96316 4.13109 6.18426 3.79245 6.37872 3.62734C6.58945 3.44842 6.86556 3.39087 7.10145 3.39087V2.39087ZM4.96316 4.87098C4.96316 5.83116 5.27443 6.48423 5.74849 6.88742C6.20531 7.27595 6.74361 7.37265 7.10146 7.37265L7.10145 6.37265C6.89961 6.37265 6.61876 6.31482 6.39636 6.12567C6.19119 5.95117 5.96316 5.6034 5.96316 4.87098H4.96316ZM7.13522 3.39087C7.37111 3.39087 7.64722 3.44842 7.85795 3.62734C8.05241 3.79245 8.27352 4.13109 8.27352 4.87098H9.27352C9.27352 3.91826 8.9784 3.26685 8.50518 2.86505C8.04822 2.47707 7.50518 2.39087 7.13522 2.39087V3.39087ZM8.27352 4.87098C8.27352 5.6034 8.04548 5.95117 7.84031 6.12567C7.61792 6.31482 7.33706 6.37265 7.13522 6.37265L7.13521 7.37265C7.49306 7.37265 8.03136 7.27595 8.48818 6.88742C8.96224 6.48423 9.27352 5.83116 9.27352 4.87098H8.27352ZM5.55477 6.89929C5.28389 7.04539 4.54211 7.38047 3.94241 7.58383L4.26355 8.53086C4.91358 8.31043 5.70698 7.95338 6.02949 7.77942L5.55477 6.89929ZM3.94241 7.58383C3.31325 7.79718 3.08232 8.35094 3.00525 8.79632C2.92849 9.23993 2.9766 9.70424 3.00677 9.96822L4.0003 9.85466C3.96992 9.58891 3.94093 9.25394 3.99061 8.96683C4.03998 8.68149 4.13905 8.57308 4.26355 8.53086L3.94241 7.58383ZM3.25371 10.3446C3.80364 10.6618 5.28189 11.2392 7.11835 11.2392V10.2392C5.46714 10.2392 4.16012 9.71295 3.75336 9.47833L3.25371 10.3446ZM8.20721 7.77942C8.52972 7.95338 9.32312 8.31043 9.97315 8.53086L10.2943 7.58383C9.69458 7.38047 8.95281 7.04539 8.68193 6.89929L8.20721 7.77942ZM9.97315 8.53086C10.0976 8.57308 10.1967 8.68149 10.2461 8.96683C10.2958 9.25394 10.2668 9.58891 10.2364 9.85466L11.2299 9.96822C11.2601 9.70423 11.3082 9.23993 11.2314 8.79632C11.1544 8.35094 10.9234 7.79718 10.2943 7.58383L9.97315 8.53086ZM10.4833 9.47833C10.0766 9.71295 8.76956 10.2392 7.11835 10.2392V11.2392C8.9548 11.2392 10.4331 10.6618 10.983 10.3446L10.4833 9.47833Z"
                            fill="#222222"
                          />
                          <path
                            d="M1.76215 3.43506C1.76215 3.15892 1.53829 2.93506 1.26215 2.93506C0.986004 2.93506 0.762146 3.15892 0.762146 3.43506H1.76215ZM13.4969 14.4057C13.7 14.2186 13.713 13.9023 13.5259 13.6992C13.3388 13.4961 13.0225 13.4831 12.8194 13.6702L13.4969 14.4057ZM1.76215 13.3626V3.43506H0.762146V13.3626H1.76215ZM13.1581 14.0379C12.8194 13.6702 12.8196 13.67 12.8198 13.6698C12.8199 13.6697 12.8201 13.6695 12.8202 13.6694C12.8205 13.6692 12.8207 13.6689 12.821 13.6687C12.8215 13.6682 12.822 13.6678 12.8225 13.6673C12.8234 13.6665 12.8243 13.6657 12.8251 13.665C12.8267 13.6635 12.828 13.6624 12.829 13.6615C12.831 13.6598 12.8318 13.6592 12.8314 13.6596C12.8305 13.6603 12.8246 13.6649 12.8136 13.6722C12.7916 13.6868 12.7488 13.7125 12.6835 13.7404C12.5544 13.7954 12.3287 13.8626 11.9884 13.8626V14.8626C12.4653 14.8626 12.8244 14.7675 13.0759 14.6602C13.2009 14.6069 13.2973 14.5514 13.367 14.5051C13.4018 14.482 13.4298 14.4612 13.4514 14.4442C13.4622 14.4357 13.4713 14.4281 13.4789 14.4216C13.4827 14.4184 13.4861 14.4154 13.4891 14.4128C13.4906 14.4114 13.4919 14.4102 13.4932 14.409C13.4939 14.4084 13.4945 14.4078 13.4951 14.4073C13.4954 14.407 13.4957 14.4067 13.496 14.4065C13.4962 14.4063 13.4964 14.4061 13.4964 14.4061C13.4967 14.4059 13.4969 14.4057 13.1581 14.0379ZM11.9884 13.8626C11.9871 13.8626 11.9858 13.8626 11.9844 13.8626C11.9831 13.8626 11.9818 13.8626 11.9804 13.8626C11.979 13.8626 11.9776 13.8626 11.9762 13.8626C11.9748 13.8626 11.9733 13.8626 11.9719 13.8626C11.9704 13.8626 11.9689 13.8626 11.9674 13.8626C11.9659 13.8626 11.9644 13.8626 11.9628 13.8626C11.9613 13.8626 11.9597 13.8626 11.9581 13.8626C11.9565 13.8626 11.9549 13.8626 11.9533 13.8626C11.9516 13.8626 11.95 13.8626 11.9483 13.8626C11.9466 13.8626 11.9449 13.8626 11.9432 13.8626C11.9415 13.8626 11.9397 13.8626 11.938 13.8626C11.9362 13.8626 11.9344 13.8626 11.9326 13.8626C11.9308 13.8626 11.9289 13.8626 11.9271 13.8626C11.9252 13.8626 11.9234 13.8626 11.9215 13.8626C11.9196 13.8626 11.9176 13.8626 11.9157 13.8626C11.9138 13.8626 11.9118 13.8626 11.9098 13.8626C11.9078 13.8626 11.9058 13.8626 11.9038 13.8626C11.9018 13.8626 11.8997 13.8626 11.8977 13.8626C11.8956 13.8626 11.8935 13.8626 11.8914 13.8626C11.8893 13.8626 11.8872 13.8626 11.885 13.8626C11.8829 13.8626 11.8807 13.8626 11.8785 13.8626C11.8763 13.8626 11.8741 13.8626 11.8718 13.8626C11.8696 13.8626 11.8674 13.8626 11.8651 13.8626C11.8628 13.8626 11.8605 13.8626 11.8582 13.8626C11.8559 13.8626 11.8535 13.8626 11.8512 13.8626C11.8488 13.8626 11.8464 13.8626 11.844 13.8626C11.8416 13.8626 11.8392 13.8626 11.8368 13.8626C11.8343 13.8626 11.8319 13.8626 11.8294 13.8626C11.8269 13.8626 11.8244 13.8626 11.8219 13.8626C11.8194 13.8626 11.8168 13.8626 11.8142 13.8626C11.8117 13.8626 11.8091 13.8626 11.8065 13.8626C11.8039 13.8626 11.8013 13.8626 11.7986 13.8626C11.796 13.8626 11.7933 13.8626 11.7906 13.8626C11.7879 13.8626 11.7852 13.8626 11.7825 13.8626C11.7798 13.8626 11.777 13.8626 11.7743 13.8626C11.7715 13.8626 11.7687 13.8626 11.7659 13.8626C11.7631 13.8626 11.7603 13.8626 11.7575 13.8626C11.7546 13.8626 11.7518 13.8626 11.7489 13.8626C11.746 13.8626 11.7431 13.8626 11.7402 13.8626C11.7372 13.8626 11.7343 13.8626 11.7313 13.8626C11.7284 13.8626 11.7254 13.8626 11.7224 13.8626C11.7194 13.8626 11.7164 13.8626 11.7134 13.8626C11.7103 13.8626 11.7073 13.8626 11.7042 13.8626C11.7011 13.8626 11.698 13.8626 11.6949 13.8626C11.6918 13.8626 11.6886 13.8626 11.6855 13.8626C11.6823 13.8626 11.6792 13.8626 11.676 13.8626C11.6728 13.8626 11.6696 13.8626 11.6663 13.8626C11.6631 13.8626 11.6599 13.8626 11.6566 13.8626C11.6533 13.8626 11.65 13.8626 11.6467 13.8626C11.6434 13.8626 11.6401 13.8626 11.6368 13.8626C11.6334 13.8626 11.6301 13.8626 11.6267 13.8626C11.6233 13.8626 11.6199 13.8626 11.6165 13.8626C11.6131 13.8626 11.6096 13.8626 11.6062 13.8626C11.6027 13.8626 11.5992 13.8626 11.5957 13.8626C11.5923 13.8626 11.5887 13.8626 11.5852 13.8626C11.5817 13.8626 11.5781 13.8626 11.5746 13.8626C11.571 13.8626 11.5674 13.8626 11.5638 13.8626C11.5602 13.8626 11.5566 13.8626 11.553 13.8626C11.5493 13.8626 11.5457 13.8626 11.542 13.8626C11.5383 13.8626 11.5346 13.8626 11.5309 13.8626C11.5272 13.8626 11.5235 13.8626 11.5197 13.8626C11.516 13.8626 11.5122 13.8626 11.5084 13.8626C11.5047 13.8626 11.5009 13.8626 11.497 13.8626C11.4932 13.8626 11.4894 13.8626 11.4855 13.8626C11.4817 13.8626 11.4778 13.8626 11.4739 13.8626C11.47 13.8626 11.4661 13.8626 11.4622 13.8626C11.4583 13.8626 11.4543 13.8626 11.4504 13.8626C11.4464 13.8626 11.4424 13.8626 11.4384 13.8626C11.4345 13.8626 11.4304 13.8626 11.4264 13.8626C11.4224 13.8626 11.4183 13.8626 11.4143 13.8626C11.4102 13.8626 11.4061 13.8626 11.402 13.8626C11.3979 13.8626 11.3938 13.8626 11.3897 13.8626C11.3856 13.8626 11.3814 13.8626 11.3772 13.8626C11.3731 13.8626 11.3689 13.8626 11.3647 13.8626C11.3605 13.8626 11.3563 13.8626 11.352 13.8626C11.3478 13.8626 11.3435 13.8626 11.3393 13.8626C11.335 13.8626 11.3307 13.8626 11.3264 13.8626C11.3221 13.8626 11.3178 13.8626 11.3135 13.8626C11.3091 13.8626 11.3048 13.8626 11.3004 13.8626C11.296 13.8626 11.2917 13.8626 11.2873 13.8626C11.2829 13.8626 11.2784 13.8626 11.274 13.8626C11.2696 13.8626 11.2651 13.8626 11.2606 13.8626C11.2562 13.8626 11.2517 13.8626 11.2472 13.8626C11.2427 13.8626 11.2382 13.8626 11.2336 13.8626C11.2291 13.8626 11.2246 13.8626 11.22 13.8626C11.2154 13.8626 11.2109 13.8626 11.2063 13.8626C11.2017 13.8626 11.197 13.8626 11.1924 13.8626C11.1878 13.8626 11.1831 13.8626 11.1785 13.8626C11.1738 13.8626 11.1691 13.8626 11.1644 13.8626C11.1597 13.8626 11.155 13.8626 11.1503 13.8626C11.1456 13.8626 11.1408 13.8626 11.1361 13.8626C11.1313 13.8626 11.1266 13.8626 11.1218 13.8626C11.117 13.8626 11.1122 13.8626 11.1074 13.8626C11.1025 13.8626 11.0977 13.8626 11.0929 13.8626C11.088 13.8626 11.0831 13.8626 11.0783 13.8626C11.0734 13.8626 11.0685 13.8626 11.0636 13.8626C11.0587 13.8626 11.0537 13.8626 11.0488 13.8626C11.0438 13.8626 11.0389 13.8626 11.0339 13.8626C11.0289 13.8626 11.024 13.8626 11.0189 13.8626C11.0139 13.8626 11.0089 13.8626 11.0039 13.8626C10.9989 13.8626 10.9938 13.8626 10.9887 13.8626C10.9837 13.8626 10.9786 13.8626 10.9735 13.8626C10.9684 13.8626 10.9633 13.8626 10.9582 13.8626C10.9531 13.8626 10.9479 13.8626 10.9428 13.8626C10.9376 13.8626 10.9324 13.8626 10.9273 13.8626C10.9221 13.8626 10.9169 13.8626 10.9117 13.8626C10.9065 13.8626 10.9012 13.8626 10.896 13.8626C10.8907 13.8626 10.8855 13.8626 10.8802 13.8626C10.875 13.8626 10.8697 13.8626 10.8644 13.8626C10.8591 13.8626 10.8538 13.8626 10.8484 13.8626C10.8431 13.8626 10.8378 13.8626 10.8324 13.8626C10.827 13.8626 10.8217 13.8626 10.8163 13.8626C10.8109 13.8626 10.8055 13.8626 10.8001 13.8626C10.7947 13.8626 10.7892 13.8626 10.7838 13.8626C10.7784 13.8626 10.7729 13.8626 10.7674 13.8626C10.762 13.8626 10.7565 13.8626 10.751 13.8626C10.7455 13.8626 10.74 13.8626 10.7345 13.8626C10.7289 13.8626 10.7234 13.8626 10.7178 13.8626C10.7123 13.8626 10.7067 13.8626 10.7011 13.8626C10.6956 13.8626 10.69 13.8626 10.6844 13.8626C10.6788 13.8626 10.6731 13.8626 10.6675 13.8626C10.6619 13.8626 10.6562 13.8626 10.6506 13.8626C10.6449 13.8626 10.6392 13.8626 10.6335 13.8626C10.6278 13.8626 10.6221 13.8626 10.6164 13.8626C10.6107 13.8626 10.605 13.8626 10.5992 13.8626C10.5935 13.8626 10.5877 13.8626 10.582 13.8626C10.5762 13.8626 10.5704 13.8626 10.5646 13.8626C10.5588 13.8626 10.553 13.8626 10.5472 13.8626C10.5414 13.8626 10.5356 13.8626 10.5297 13.8626C10.5239 13.8626 10.518 13.8626 10.5121 13.8626C10.5063 13.8626 10.5004 13.8626 10.4945 13.8626C10.4886 13.8626 10.4827 13.8626 10.4768 13.8626C10.4708 13.8626 10.4649 13.8626 10.4589 13.8626C10.453 13.8626 10.447 13.8626 10.4411 13.8626C10.4351 13.8626 10.4291 13.8626 10.4231 13.8626C10.4171 13.8626 10.4111 13.8626 10.4051 13.8626C10.3991 13.8626 10.393 13.8626 10.387 13.8626C10.3809 13.8626 10.3749 13.8626 10.3688 13.8626C10.3627 13.8626 10.3566 13.8626 10.3505 13.8626C10.3444 13.8626 10.3383 13.8626 10.3322 13.8626C10.3261 13.8626 10.3199 13.8626 10.3138 13.8626C10.3077 13.8626 10.3015 13.8626 10.2953 13.8626C10.2892 13.8626 10.283 13.8626 10.2768 13.8626C10.2706 13.8626 10.2644 13.8626 10.2582 13.8626C10.2519 13.8626 10.2457 13.8626 10.2395 13.8626C10.2332 13.8626 10.227 13.8626 10.2207 13.8626C10.2145 13.8626 10.2082 13.8626 10.2019 13.8626C10.1956 13.8626 10.1893 13.8626 10.183 13.8626C10.1767 13.8626 10.1704 13.8626 10.164 13.8626C10.1577 13.8626 10.1513 13.8626 10.145 13.8626C10.1386 13.8626 10.1323 13.8626 10.1259 13.8626C10.1195 13.8626 10.1131 13.8626 10.1067 13.8626C10.1003 13.8626 10.0939 13.8626 10.0875 13.8626C10.0811 13.8626 10.0746 13.8626 10.0682 13.8626C10.0617 13.8626 10.0553 13.8626 10.0488 13.8626C10.0423 13.8626 10.0358 13.8626 10.0294 13.8626C10.0229 13.8626 10.0164 13.8626 10.0099 13.8626C10.0033 13.8626 9.99682 13.8626 9.99028 13.8626C9.98375 13.8626 9.9772 13.8626 9.97065 13.8626C9.96409 13.8626 9.95753 13.8626 9.95095 13.8626C9.94437 13.8626 9.93778 13.8626 9.93118 13.8626C9.92459 13.8626 9.91798 13.8626 9.91136 13.8626C9.90474 13.8626 9.89811 13.8626 9.89147 13.8626C9.88483 13.8626 9.87818 13.8626 9.87152 13.8626C9.86486 13.8626 9.85818 13.8626 9.8515 13.8626C9.84482 13.8626 9.83813 13.8626 9.83143 13.8626C9.82472 13.8626 9.81801 13.8626 9.81129 13.8626C9.80457 13.8626 9.79783 13.8626 9.79109 13.8626C9.78435 13.8626 9.7776 13.8626 9.77083 13.8626C9.76407 13.8626 9.7573 13.8626 9.75051 13.8626C9.74373 13.8626 9.73694 13.8626 9.73014 13.8626C9.72333 13.8626 9.71652 13.8626 9.7097 13.8626C9.70288 13.8626 9.69605 13.8626 9.6892 13.8626C9.68236 13.8626 9.67551 13.8626 9.66865 13.8626C9.66179 13.8626 9.65492 13.8626 9.64804 13.8626C9.64116 13.8626 9.63427 13.8626 9.62737 13.8626C9.62047 13.8626 9.61356 13.8626 9.60665 13.8626C9.59973 13.8626 9.5928 13.8626 9.58586 13.8626C9.57893 13.8626 9.57198 13.8626 9.56503 13.8626C9.55807 13.8626 9.55111 13.8626 9.54413 13.8626C9.53716 13.8626 9.53018 13.8626 9.52318 13.8626C9.51619 13.8626 9.50919 13.8626 9.50218 13.8626C9.49517 13.8626 9.48815 13.8626 9.48112 13.8626C9.4741 13.8626 9.46706 13.8626 9.46001 13.8626C9.45297 13.8626 9.44591 13.8626 9.43885 13.8626C9.43179 13.8626 9.42471 13.8626 9.41763 13.8626C9.41055 13.8626 9.40346 13.8626 9.39636 13.8626C9.38926 13.8626 9.38216 13.8626 9.37504 13.8626C9.36793 13.8626 9.3608 13.8626 9.35367 13.8626C9.34654 13.8626 9.33939 13.8626 9.33224 13.8626C9.32509 13.8626 9.31794 13.8626 9.31077 13.8626C9.3036 13.8626 9.29643 13.8626 9.28924 13.8626C9.28206 13.8626 9.27487 13.8626 9.26767 13.8626C9.26047 13.8626 9.25326 13.8626 9.24605 13.8626C9.23883 13.8626 9.23161 13.8626 9.22437 13.8626C9.21714 13.8626 9.2099 13.8626 9.20265 13.8626C9.1954 13.8626 9.18815 13.8626 9.18088 13.8626C9.17362 13.8626 9.16635 13.8626 9.15907 13.8626C9.15179 13.8626 9.1445 13.8626 9.1372 13.8626C9.12991 13.8626 9.1226 13.8626 9.11529 13.8626C9.10798 13.8626 9.10066 13.8626 9.09333 13.8626C9.08601 13.8626 9.07867 13.8626 9.07133 13.8626C9.06399 13.8626 9.05664 13.8626 9.04928 13.8626C9.04193 13.8626 9.03456 13.8626 9.02719 13.8626C9.01982 13.8626 9.01244 13.8626 9.00505 13.8626C8.99767 13.8626 8.99027 13.8626 8.98287 13.8626C8.97547 13.8626 8.96806 13.8626 8.96065 13.8626C8.95323 13.8626 8.94581 13.8626 8.93838 13.8626C8.93095 13.8626 8.92351 13.8626 8.91607 13.8626C8.90862 13.8626 8.90117 13.8626 8.89372 13.8626C8.88626 13.8626 8.87879 13.8626 8.87132 13.8626C8.86385 13.8626 8.85637 13.8626 8.84888 13.8626C8.8414 13.8626 8.83391 13.8626 8.82641 13.8626C8.81891 13.8626 8.8114 13.8626 8.80389 13.8626C8.79638 13.8626 8.78886 13.8626 8.78133 13.8626C8.77381 13.8626 8.76627 13.8626 8.75874 13.8626C8.7512 13.8626 8.74365 13.8626 8.7361 13.8626C8.72855 13.8626 8.72099 13.8626 8.71342 13.8626C8.70586 13.8626 8.69829 13.8626 8.69071 13.8626C8.68313 13.8626 8.67555 13.8626 8.66796 13.8626C8.66037 13.8626 8.65277 13.8626 8.64517 13.8626C8.63757 13.8626 8.62996 13.8626 8.62235 13.8626C8.61473 13.8626 8.60711 13.8626 8.59948 13.8626C8.59186 13.8626 8.58422 13.8626 8.57659 13.8626C8.56895 13.8626 8.5613 13.8626 8.55365 13.8626C8.546 13.8626 8.53834 13.8626 8.53068 13.8626C8.52302 13.8626 8.51535 13.8626 8.50768 13.8626C8.50001 13.8626 8.49233 13.8626 8.48464 13.8626C8.47696 13.8626 8.46927 13.8626 8.46157 13.8626C8.45387 13.8626 8.44617 13.8626 8.43846 13.8626C8.43076 13.8626 8.42304 13.8626 8.41533 13.8626C8.40761 13.8626 8.39988 13.8626 8.39216 13.8626C8.38443 13.8626 8.37669 13.8626 8.36895 13.8626C8.36121 13.8626 8.35347 13.8626 8.34572 13.8626C8.33797 13.8626 8.33021 13.8626 8.32245 13.8626C8.31469 13.8626 8.30693 13.8626 8.29916 13.8626C8.29139 13.8626 8.28361 13.8626 8.27583 13.8626C8.26805 13.8626 8.26026 13.8626 8.25247 13.8626C8.24468 13.8626 8.23689 13.8626 8.22909 13.8626C8.22129 13.8626 8.21348 13.8626 8.20567 13.8626C8.19786 13.8626 8.19005 13.8626 8.18223 13.8626C8.17441 13.8626 8.16658 13.8626 8.15876 13.8626C8.15093 13.8626 8.1431 13.8626 8.13526 13.8626C8.12742 13.8626 8.11958 13.8626 8.11173 13.8626C8.10388 13.8626 8.09603 13.8626 8.08818 13.8626C8.08032 13.8626 8.07246 13.8626 8.0646 13.8626C8.05673 13.8626 8.04886 13.8626 8.04099 13.8626C8.03312 13.8626 8.02524 13.8626 8.01736 13.8626C8.00948 13.8626 8.00159 13.8626 7.9937 13.8626C7.98582 13.8626 7.97792 13.8626 7.97002 13.8626C7.96213 13.8626 7.95423 13.8626 7.94632 13.8626C7.93841 13.8626 7.9305 13.8626 7.92259 13.8626C7.91468 13.8626 7.90676 13.8626 7.89884 13.8626C7.89092 13.8626 7.88299 13.8626 7.87506 13.8626C7.86714 13.8626 7.8592 13.8626 7.85127 13.8626C7.84333 13.8626 7.83539 13.8626 7.82745 13.8626C7.81951 13.8626 7.81156 13.8626 7.80361 13.8626C7.79566 13.8626 7.7877 13.8626 7.77975 13.8626C7.77179 13.8626 7.76383 13.8626 7.75587 13.8626C7.7479 13.8626 7.73993 13.8626 7.73196 13.8626C7.72399 13.8626 7.71602 13.8626 7.70804 13.8626C7.70006 13.8626 7.69208 13.8626 7.6841 13.8626C7.67612 13.8626 7.66813 13.8626 7.66014 13.8626C7.65215 13.8626 7.64416 13.8626 7.63616 13.8626C7.62817 13.8626 7.62017 13.8626 7.61217 13.8626C7.60416 13.8626 7.59616 13.8626 7.58815 13.8626C7.58014 13.8626 7.57213 13.8626 7.56412 13.8626C7.55611 13.8626 7.54809 13.8626 7.54007 13.8626C7.53206 13.8626 7.52403 13.8626 7.51601 13.8626C7.50799 13.8626 7.49996 13.8626 7.49193 13.8626C7.4839 13.8626 7.47587 13.8626 7.46784 13.8626C7.4598 13.8626 7.45177 13.8626 7.44373 13.8626C7.43569 13.8626 7.42765 13.8626 7.4196 13.8626C7.41156 13.8626 7.40351 13.8626 7.39546 13.8626C7.38742 13.8626 7.37937 13.8626 7.37131 13.8626C7.36326 13.8626 7.35521 13.8626 7.34715 13.8626C7.33909 13.8626 7.33103 13.8626 7.32297 13.8626C7.31491 13.8626 7.30685 13.8626 7.29878 13.8626C7.29072 13.8626 7.28265 13.8626 7.27458 13.8626C7.26651 13.8626 7.25844 13.8626 7.25037 13.8626C7.2423 13.8626 7.23422 13.8626 7.22615 13.8626C7.21807 13.8626 7.20999 13.8626 7.20191 13.8626C7.19383 13.8626 7.18575 13.8626 7.17767 13.8626C7.16959 13.8626 7.1615 13.8626 7.15341 13.8626C7.14533 13.8626 7.13724 13.8626 7.12915 13.8626C7.12106 13.8626 7.11297 13.8626 7.10488 13.8626C7.09679 13.8626 7.0887 13.8626 7.0806 13.8626C7.07251 13.8626 7.06441 13.8626 7.05631 13.8626C7.04822 13.8626 7.04012 13.8626 7.03202 13.8626C7.02392 13.8626 7.01582 13.8626 7.00772 13.8626C6.99962 13.8626 6.99152 13.8626 6.98341 13.8626C6.97531 13.8626 6.9672 13.8626 6.9591 13.8626C6.95099 13.8626 6.94289 13.8626 6.93478 13.8626C6.92667 13.8626 6.91856 13.8626 6.91045 13.8626C6.90234 13.8626 6.89424 13.8626 6.88612 13.8626C6.87801 13.8626 6.8699 13.8626 6.86179 13.8626C6.85368 13.8626 6.84557 13.8626 6.83745 13.8626C6.82934 13.8626 6.82123 13.8626 6.81311 13.8626C6.805 13.8626 6.79688 13.8626 6.78877 13.8626C6.78065 13.8626 6.77254 13.8626 6.76442 13.8626C6.75631 13.8626 6.74819 13.8626 6.74008 13.8626C6.73196 13.8626 6.72384 13.8626 6.71573 13.8626C6.70761 13.8626 6.69949 13.8626 6.69138 13.8626C6.68326 13.8626 6.67514 13.8626 6.66702 13.8626C6.65891 13.8626 6.65079 13.8626 6.64267 13.8626C6.63455 13.8626 6.62644 13.8626 6.61832 13.8626C6.6102 13.8626 6.60209 13.8626 6.59397 13.8626C6.58585 13.8626 6.57774 13.8626 6.56962 13.8626C6.5615 13.8626 6.55339 13.8626 6.54527 13.8626C6.53715 13.8626 6.52904 13.8626 6.52092 13.8626C6.51281 13.8626 6.50469 13.8626 6.49658 13.8626C6.48847 13.8626 6.48035 13.8626 6.47224 13.8626C6.46413 13.8626 6.45601 13.8626 6.4479 13.8626C6.43979 13.8626 6.43168 13.8626 6.42357 13.8626C6.41546 13.8626 6.40735 13.8626 6.39924 13.8626C6.39113 13.8626 6.38302 13.8626 6.37491 13.8626C6.3668 13.8626 6.3587 13.8626 6.35059 13.8626C6.34248 13.8626 6.33438 13.8626 6.32627 13.8626C6.31817 13.8626 6.31007 13.8626 6.30197 13.8626C6.29386 13.8626 6.28576 13.8626 6.27766 13.8626C6.26956 13.8626 6.26146 13.8626 6.25337 13.8626C6.24527 13.8626 6.23717 13.8626 6.22908 13.8626C6.22098 13.8626 6.21289 13.8626 6.2048 13.8626C6.1967 13.8626 6.18861 13.8626 6.18052 13.8626C6.17243 13.8626 6.16435 13.8626 6.15626 13.8626C6.14817 13.8626 6.14009 13.8626 6.132 13.8626C6.12392 13.8626 6.11584 13.8626 6.10776 13.8626C6.09968 13.8626 6.0916 13.8626 6.08352 13.8626C6.07544 13.8626 6.06737 13.8626 6.0593 13.8626C6.05122 13.8626 6.04315 13.8626 6.03508 13.8626C6.02701 13.8626 6.01894 13.8626 6.01088 13.8626C6.00281 13.8626 5.99475 13.8626 5.98668 13.8626C5.97862 13.8626 5.97056 13.8626 5.9625 13.8626C5.95445 13.8626 5.94639 13.8626 5.93834 13.8626C5.93028 13.8626 5.92223 13.8626 5.91418 13.8626C5.90613 13.8626 5.89809 13.8626 5.89004 13.8626C5.882 13.8626 5.87395 13.8626 5.86591 13.8626C5.85787 13.8626 5.84984 13.8626 5.8418 13.8626C5.83377 13.8626 5.82573 13.8626 5.8177 13.8626C5.80967 13.8626 5.80164 13.8626 5.79362 13.8626C5.78559 13.8626 5.77757 13.8626 5.76955 13.8626C5.76153 13.8626 5.75352 13.8626 5.7455 13.8626C5.73749 13.8626 5.72948 13.8626 5.72147 13.8626C5.71346 13.8626 5.70545 13.8626 5.69745 13.8626C5.68945 13.8626 5.68145 13.8626 5.67345 13.8626C5.66545 13.8626 5.65746 13.8626 5.64947 13.8626C5.64147 13.8626 5.63349 13.8626 5.6255 13.8626C5.61752 13.8626 5.60953 13.8626 5.60156 13.8626C5.59358 13.8626 5.5856 13.8626 5.57763 13.8626C5.56966 13.8626 5.56169 13.8626 5.55372 13.8626C5.54576 13.8626 5.53779 13.8626 5.52984 13.8626C5.52188 13.8626 5.51392 13.8626 5.50597 13.8626C5.49802 13.8626 5.49007 13.8626 5.48212 13.8626C5.47418 13.8626 5.46624 13.8626 5.4583 13.8626C5.45036 13.8626 5.44243 13.8626 5.4345 13.8626C5.42657 13.8626 5.41864 13.8626 5.41072 13.8626C5.4028 13.8626 5.39488 13.8626 5.38696 13.8626C5.37905 13.8626 5.37113 13.8626 5.36323 13.8626C5.35532 13.8626 5.34742 13.8626 5.33952 13.8626C5.33162 13.8626 5.32372 13.8626 5.31583 13.8626C5.30794 13.8626 5.30005 13.8626 5.29217 13.8626C5.28429 13.8626 5.27641 13.8626 5.26853 13.8626C5.26066 13.8626 5.25279 13.8626 5.24492 13.8626C5.23705 13.8626 5.22919 13.8626 5.22133 13.8626C5.21348 13.8626 5.20562 13.8626 5.19777 13.8626C5.18993 13.8626 5.18208 13.8626 5.17424 13.8626C5.1664 13.8626 5.15857 13.8626 5.15074 13.8626C5.14291 13.8626 5.13508 13.8626 5.12726 13.8626C5.11944 13.8626 5.11162 13.8626 5.10381 13.8626C5.096 13.8626 5.08819 13.8626 5.08039 13.8626C5.07258 13.8626 5.06479 13.8626 5.05699 13.8626C5.0492 13.8626 5.04141 13.8626 5.03363 13.8626C5.02585 13.8626 5.01807 13.8626 5.0103 13.8626C5.00252 13.8626 4.99476 13.8626 4.98699 13.8626C4.97923 13.8626 4.97147 13.8626 4.96372 13.8626C4.95597 13.8626 4.94822 13.8626 4.94048 13.8626C4.93274 13.8626 4.925 13.8626 4.91727 13.8626C4.90954 13.8626 4.90181 13.8626 4.89409 13.8626C4.88637 13.8626 4.87865 13.8626 4.87094 13.8626C4.86323 13.8626 4.85553 13.8626 4.84783 13.8626C4.84013 13.8626 4.83244 13.8626 4.82475 13.8626C4.81706 13.8626 4.80938 13.8626 4.80171 13.8626C4.79403 13.8626 4.78636 13.8626 4.77869 13.8626C4.77103 13.8626 4.76337 13.8626 4.75572 13.8626C4.74806 13.8626 4.74042 13.8626 4.73277 13.8626C4.72513 13.8626 4.7175 13.8626 4.70987 13.8626C4.70224 13.8626 4.69461 13.8626 4.687 13.8626C4.67938 13.8626 4.67177 13.8626 4.66416 13.8626C4.65656 13.8626 4.64896 13.8626 4.64137 13.8626C4.63377 13.8626 4.62619 13.8626 4.61861 13.8626C4.61103 13.8626 4.60345 13.8626 4.59588 13.8626C4.58832 13.8626 4.58075 13.8626 4.5732 13.8626C4.56564 13.8626 4.5581 13.8626 4.55055 13.8626C4.54301 13.8626 4.53548 13.8626 4.52795 13.8626C4.52042 13.8626 4.5129 13.8626 4.50538 13.8626C4.49787 13.8626 4.49036 13.8626 4.48285 13.8626C4.47535 13.8626 4.46786 13.8626 4.46037 13.8626C4.45288 13.8626 4.4454 13.8626 4.43792 13.8626C4.43045 13.8626 4.42298 13.8626 4.41552 13.8626C4.40806 13.8626 4.4006 13.8626 4.39315 13.8626C4.38571 13.8626 4.37827 13.8626 4.37083 13.8626C4.3634 13.8626 4.35597 13.8626 4.34856 13.8626C4.34114 13.8626 4.33372 13.8626 4.32632 13.8626C4.31892 13.8626 4.31152 13.8626 4.30413 13.8626C4.29674 13.8626 4.28936 13.8626 4.28198 13.8626C4.27461 13.8626 4.26724 13.8626 4.25988 13.8626C4.25252 13.8626 4.24516 13.8626 4.23782 13.8626C4.23047 13.8626 4.22314 13.8626 4.21581 13.8626C4.20848 13.8626 4.20115 13.8626 4.19384 13.8626C4.18652 13.8626 4.17922 13.8626 4.17192 13.8626C4.16462 13.8626 4.15733 13.8626 4.15004 13.8626C4.14276 13.8626 4.13548 13.8626 4.12821 13.8626C4.12095 13.8626 4.11369 13.8626 4.10643 13.8626C4.09918 13.8626 4.09194 13.8626 4.0847 13.8626C4.07746 13.8626 4.07024 13.8626 4.06302 13.8626C4.0558 13.8626 4.04858 13.8626 4.04138 13.8626C4.03418 13.8626 4.02698 13.8626 4.0198 13.8626C4.01261 13.8626 4.00543 13.8626 3.99826 13.8626C3.99109 13.8626 3.98393 13.8626 3.97677 13.8626C3.96962 13.8626 3.96247 13.8626 3.95534 13.8626C3.9482 13.8626 3.94107 13.8626 3.93395 13.8626C3.92683 13.8626 3.91972 13.8626 3.91262 13.8626C3.90552 13.8626 3.89842 13.8626 3.89134 13.8626C3.88425 13.8626 3.87717 13.8626 3.87011 13.8626C3.86304 13.8626 3.85598 13.8626 3.84893 13.8626C3.84188 13.8626 3.83484 13.8626 3.82781 13.8626C3.82077 13.8626 3.81375 13.8626 3.80674 13.8626C3.79972 13.8626 3.79272 13.8626 3.78572 13.8626C3.77872 13.8626 3.77174 13.8626 3.76476 13.8626C3.75778 13.8626 3.75081 13.8626 3.74385 13.8626C3.73689 13.8626 3.72994 13.8626 3.723 13.8626C3.71606 13.8626 3.70913 13.8626 3.70221 13.8626C3.69529 13.8626 3.68837 13.8626 3.68147 13.8626C3.67457 13.8626 3.66767 13.8626 3.66079 13.8626C3.6539 13.8626 3.64703 13.8626 3.64016 13.8626C3.6333 13.8626 3.62644 13.8626 3.6196 13.8626C3.61275 13.8626 3.60591 13.8626 3.59909 13.8626C3.59226 13.8626 3.58544 13.8626 3.57864 13.8626C3.57183 13.8626 3.56503 13.8626 3.55824 13.8626C3.55146 13.8626 3.54468 13.8626 3.53791 13.8626C3.53114 13.8626 3.52439 13.8626 3.51764 13.8626C3.51089 13.8626 3.50415 13.8626 3.49743 13.8626C3.4907 13.8626 3.48398 13.8626 3.47728 13.8626C3.47057 13.8626 3.46387 13.8626 3.45719 13.8626C3.4505 13.8626 3.44382 13.8626 3.43716 13.8626C3.43049 13.8626 3.42383 13.8626 3.41719 13.8626C3.41054 13.8626 3.40391 13.8626 3.39729 13.8626C3.39066 13.8626 3.38405 13.8626 3.37744 13.8626C3.37084 13.8626 3.36425 13.8626 3.35767 13.8626C3.35108 13.8626 3.34451 13.8626 3.33795 13.8626C3.33139 13.8626 3.32484 13.8626 3.3183 13.8626C3.31176 13.8626 3.30523 13.8626 3.29872 13.8626C3.2922 13.8626 3.28569 13.8626 3.2792 13.8626C3.2727 13.8626 3.26622 13.8626 3.25974 13.8626C3.25327 13.8626 3.2468 13.8626 3.24035 13.8626C3.2339 13.8626 3.22746 13.8626 3.22103 13.8626C3.2146 13.8626 3.20818 13.8626 3.20178 13.8626C3.19537 13.8626 3.18897 13.8626 3.18259 13.8626C3.1762 13.8626 3.16983 13.8626 3.16347 13.8626C3.15711 13.8626 3.15075 13.8626 3.14442 13.8626C3.13808 13.8626 3.13175 13.8626 3.12543 13.8626C3.11912 13.8626 3.11281 13.8626 3.10652 13.8626C3.10022 13.8626 3.09394 13.8626 3.08767 13.8626C3.0814 13.8626 3.07515 13.8626 3.0689 13.8626C3.06265 13.8626 3.05642 13.8626 3.05019 13.8626C3.04397 13.8626 3.03776 13.8626 3.03156 13.8626C3.02536 13.8626 3.01917 13.8626 3.013 13.8626C3.00682 13.8626 3.00066 13.8626 2.99451 13.8626C2.98836 13.8626 2.98222 13.8626 2.97609 13.8626C2.96996 13.8626 2.96385 13.8626 2.95775 13.8626C2.95164 13.8626 2.94555 13.8626 2.93947 13.8626C2.93339 13.8626 2.92733 13.8626 2.92127 13.8626C2.91522 13.8626 2.90918 13.8626 2.90315 13.8626C2.89712 13.8626 2.8911 13.8626 2.8851 13.8626C2.87909 13.8626 2.8731 13.8626 2.86712 13.8626C2.86114 13.8626 2.85518 13.8626 2.84922 13.8626C2.84327 13.8626 2.83733 13.8626 2.8314 13.8626C2.82547 13.8626 2.81955 13.8626 2.81365 13.8626C2.80775 13.8626 2.80186 13.8626 2.79598 13.8626C2.7901 13.8626 2.78423 13.8626 2.77838 13.8626C2.77253 13.8626 2.76669 13.8626 2.76087 13.8626C2.75504 13.8626 2.74923 13.8626 2.74343 13.8626C2.73763 13.8626 2.73184 13.8626 2.72606 13.8626C2.72029 13.8626 2.71453 13.8626 2.70878 13.8626C2.70304 13.8626 2.6973 13.8626 2.69158 13.8626C2.68586 13.8626 2.68015 13.8626 2.67446 13.8626C2.66876 13.8626 2.66308 13.8626 2.65741 13.8626C2.65175 13.8626 2.64609 13.8626 2.64045 13.8626C2.63481 13.8626 2.62918 13.8626 2.62357 13.8626C2.61796 13.8626 2.61236 13.8626 2.60677 13.8626C2.60118 13.8626 2.59561 13.8626 2.59005 13.8626C2.58449 13.8626 2.57895 13.8626 2.57342 13.8626C2.56788 13.8626 2.56237 13.8626 2.55686 13.8626C2.55136 13.8626 2.54587 13.8626 2.54039 13.8626C2.53492 13.8626 2.52946 13.8626 2.52401 13.8626C2.51856 13.8626 2.51313 13.8626 2.50771 13.8626C2.50229 13.8626 2.49688 13.8626 2.49149 13.8626C2.4861 13.8626 2.48072 13.8626 2.47536 13.8626C2.46999 13.8626 2.46464 13.8626 2.45931 13.8626C2.45397 13.8626 2.44865 13.8626 2.44335 13.8626C2.43804 13.8626 2.43275 13.8626 2.42747 13.8626C2.4222 13.8626 2.41693 13.8626 2.41169 13.8626C2.40644 13.8626 2.4012 13.8626 2.39598 13.8626C2.39077 13.8626 2.38556 13.8626 2.38037 13.8626C2.37518 13.8626 2.37001 13.8626 2.36485 13.8626C2.35969 13.8626 2.35454 13.8626 2.34941 13.8626C2.34428 13.8626 2.33916 13.8626 2.33406 13.8626C2.32896 13.8626 2.32388 13.8626 2.31881 13.8626C2.31373 13.8626 2.30868 13.8626 2.30364 13.8626C2.2986 13.8626 2.29357 13.8626 2.28856 13.8626C2.28355 13.8626 2.27855 13.8626 2.27357 13.8626C2.26859 13.8626 2.26363 13.8626 2.25868 13.8626V14.8626C2.26363 14.8626 2.26859 14.8626 2.27357 14.8626C2.27855 14.8626 2.28355 14.8626 2.28856 14.8626C2.29357 14.8626 2.2986 14.8626 2.30364 14.8626C2.30868 14.8626 2.31373 14.8626 2.31881 14.8626C2.32388 14.8626 2.32896 14.8626 2.33406 14.8626C2.33916 14.8626 2.34428 14.8626 2.34941 14.8626C2.35454 14.8626 2.35969 14.8626 2.36485 14.8626C2.37001 14.8626 2.37518 14.8626 2.38037 14.8626C2.38556 14.8626 2.39077 14.8626 2.39598 14.8626C2.4012 14.8626 2.40644 14.8626 2.41169 14.8626C2.41693 14.8626 2.4222 14.8626 2.42747 14.8626C2.43275 14.8626 2.43804 14.8626 2.44335 14.8626C2.44865 14.8626 2.45397 14.8626 2.45931 14.8626C2.46464 14.8626 2.46999 14.8626 2.47536 14.8626C2.48072 14.8626 2.4861 14.8626 2.49149 14.8626C2.49688 14.8626 2.50229 14.8626 2.50771 14.8626C2.51313 14.8626 2.51856 14.8626 2.52401 14.8626C2.52946 14.8626 2.53492 14.8626 2.54039 14.8626C2.54587 14.8626 2.55136 14.8626 2.55686 14.8626C2.56237 14.8626 2.56788 14.8626 2.57342 14.8626C2.57895 14.8626 2.58449 14.8626 2.59005 14.8626C2.59561 14.8626 2.60118 14.8626 2.60677 14.8626C2.61236 14.8626 2.61796 14.8626 2.62357 14.8626C2.62918 14.8626 2.63481 14.8626 2.64045 14.8626C2.64609 14.8626 2.65175 14.8626 2.65741 14.8626C2.66308 14.8626 2.66876 14.8626 2.67446 14.8626C2.68015 14.8626 2.68586 14.8626 2.69158 14.8626C2.6973 14.8626 2.70304 14.8626 2.70878 14.8626C2.71453 14.8626 2.72029 14.8626 2.72606 14.8626C2.73184 14.8626 2.73763 14.8626 2.74343 14.8626C2.74923 14.8626 2.75504 14.8626 2.76087 14.8626C2.76669 14.8626 2.77253 14.8626 2.77838 14.8626C2.78423 14.8626 2.7901 14.8626 2.79598 14.8626C2.80186 14.8626 2.80775 14.8626 2.81365 14.8626C2.81955 14.8626 2.82547 14.8626 2.8314 14.8626C2.83733 14.8626 2.84327 14.8626 2.84922 14.8626C2.85518 14.8626 2.86114 14.8626 2.86712 14.8626C2.8731 14.8626 2.87909 14.8626 2.8851 14.8626C2.8911 14.8626 2.89712 14.8626 2.90315 14.8626C2.90918 14.8626 2.91522 14.8626 2.92127 14.8626C2.92733 14.8626 2.93339 14.8626 2.93947 14.8626C2.94555 14.8626 2.95164 14.8626 2.95775 14.8626C2.96385 14.8626 2.96996 14.8626 2.97609 14.8626C2.98222 14.8626 2.98836 14.8626 2.99451 14.8626C3.00066 14.8626 3.00682 14.8626 3.013 14.8626C3.01917 14.8626 3.02536 14.8626 3.03156 14.8626C3.03776 14.8626 3.04397 14.8626 3.05019 14.8626C3.05642 14.8626 3.06265 14.8626 3.0689 14.8626C3.07515 14.8626 3.0814 14.8626 3.08767 14.8626C3.09394 14.8626 3.10022 14.8626 3.10652 14.8626C3.11281 14.8626 3.11912 14.8626 3.12543 14.8626C3.13175 14.8626 3.13808 14.8626 3.14442 14.8626C3.15075 14.8626 3.15711 14.8626 3.16347 14.8626C3.16983 14.8626 3.1762 14.8626 3.18259 14.8626C3.18897 14.8626 3.19537 14.8626 3.20178 14.8626C3.20818 14.8626 3.2146 14.8626 3.22103 14.8626C3.22746 14.8626 3.2339 14.8626 3.24035 14.8626C3.2468 14.8626 3.25327 14.8626 3.25974 14.8626C3.26622 14.8626 3.2727 14.8626 3.2792 14.8626C3.28569 14.8626 3.2922 14.8626 3.29872 14.8626C3.30523 14.8626 3.31176 14.8626 3.3183 14.8626C3.32484 14.8626 3.33139 14.8626 3.33795 14.8626C3.34451 14.8626 3.35108 14.8626 3.35767 14.8626C3.36425 14.8626 3.37084 14.8626 3.37744 14.8626C3.38405 14.8626 3.39066 14.8626 3.39729 14.8626C3.40391 14.8626 3.41054 14.8626 3.41719 14.8626C3.42383 14.8626 3.43049 14.8626 3.43716 14.8626C3.44382 14.8626 3.4505 14.8626 3.45719 14.8626C3.46387 14.8626 3.47057 14.8626 3.47728 14.8626C3.48398 14.8626 3.4907 14.8626 3.49743 14.8626C3.50415 14.8626 3.51089 14.8626 3.51764 14.8626C3.52439 14.8626 3.53114 14.8626 3.53791 14.8626C3.54468 14.8626 3.55146 14.8626 3.55824 14.8626C3.56503 14.8626 3.57183 14.8626 3.57864 14.8626C3.58544 14.8626 3.59226 14.8626 3.59909 14.8626C3.60591 14.8626 3.61275 14.8626 3.6196 14.8626C3.62644 14.8626 3.6333 14.8626 3.64016 14.8626C3.64703 14.8626 3.6539 14.8626 3.66079 14.8626C3.66767 14.8626 3.67457 14.8626 3.68147 14.8626C3.68837 14.8626 3.69529 14.8626 3.70221 14.8626C3.70913 14.8626 3.71606 14.8626 3.723 14.8626C3.72994 14.8626 3.73689 14.8626 3.74385 14.8626C3.75081 14.8626 3.75778 14.8626 3.76476 14.8626C3.77174 14.8626 3.77872 14.8626 3.78572 14.8626C3.79272 14.8626 3.79972 14.8626 3.80674 14.8626C3.81375 14.8626 3.82077 14.8626 3.82781 14.8626C3.83484 14.8626 3.84188 14.8626 3.84893 14.8626C3.85598 14.8626 3.86304 14.8626 3.87011 14.8626C3.87717 14.8626 3.88425 14.8626 3.89134 14.8626C3.89842 14.8626 3.90552 14.8626 3.91262 14.8626C3.91972 14.8626 3.92683 14.8626 3.93395 14.8626C3.94107 14.8626 3.9482 14.8626 3.95534 14.8626C3.96247 14.8626 3.96962 14.8626 3.97677 14.8626C3.98393 14.8626 3.99109 14.8626 3.99826 14.8626C4.00543 14.8626 4.01261 14.8626 4.0198 14.8626C4.02698 14.8626 4.03418 14.8626 4.04138 14.8626C4.04858 14.8626 4.0558 14.8626 4.06302 14.8626C4.07024 14.8626 4.07746 14.8626 4.0847 14.8626C4.09194 14.8626 4.09918 14.8626 4.10643 14.8626C4.11369 14.8626 4.12095 14.8626 4.12821 14.8626C4.13548 14.8626 4.14276 14.8626 4.15004 14.8626C4.15733 14.8626 4.16462 14.8626 4.17192 14.8626C4.17922 14.8626 4.18652 14.8626 4.19384 14.8626C4.20115 14.8626 4.20848 14.8626 4.21581 14.8626C4.22314 14.8626 4.23047 14.8626 4.23782 14.8626C4.24516 14.8626 4.25252 14.8626 4.25988 14.8626C4.26724 14.8626 4.27461 14.8626 4.28198 14.8626C4.28936 14.8626 4.29674 14.8626 4.30413 14.8626C4.31152 14.8626 4.31892 14.8626 4.32632 14.8626C4.33372 14.8626 4.34114 14.8626 4.34856 14.8626C4.35597 14.8626 4.3634 14.8626 4.37083 14.8626C4.37827 14.8626 4.38571 14.8626 4.39315 14.8626C4.4006 14.8626 4.40806 14.8626 4.41552 14.8626C4.42298 14.8626 4.43045 14.8626 4.43792 14.8626C4.4454 14.8626 4.45288 14.8626 4.46037 14.8626C4.46786 14.8626 4.47535 14.8626 4.48285 14.8626C4.49036 14.8626 4.49787 14.8626 4.50538 14.8626C4.5129 14.8626 4.52042 14.8626 4.52795 14.8626C4.53548 14.8626 4.54301 14.8626 4.55055 14.8626C4.5581 14.8626 4.56564 14.8626 4.5732 14.8626C4.58075 14.8626 4.58832 14.8626 4.59588 14.8626C4.60345 14.8626 4.61103 14.8626 4.61861 14.8626C4.62619 14.8626 4.63377 14.8626 4.64137 14.8626C4.64896 14.8626 4.65656 14.8626 4.66416 14.8626C4.67177 14.8626 4.67938 14.8626 4.687 14.8626C4.69461 14.8626 4.70224 14.8626 4.70987 14.8626C4.7175 14.8626 4.72513 14.8626 4.73277 14.8626C4.74042 14.8626 4.74806 14.8626 4.75572 14.8626C4.76337 14.8626 4.77103 14.8626 4.77869 14.8626C4.78636 14.8626 4.79403 14.8626 4.80171 14.8626C4.80938 14.8626 4.81706 14.8626 4.82475 14.8626C4.83244 14.8626 4.84013 14.8626 4.84783 14.8626C4.85553 14.8626 4.86323 14.8626 4.87094 14.8626C4.87865 14.8626 4.88637 14.8626 4.89409 14.8626C4.90181 14.8626 4.90954 14.8626 4.91727 14.8626C4.925 14.8626 4.93274 14.8626 4.94048 14.8626C4.94822 14.8626 4.95597 14.8626 4.96372 14.8626C4.97147 14.8626 4.97923 14.8626 4.98699 14.8626C4.99476 14.8626 5.00252 14.8626 5.0103 14.8626C5.01807 14.8626 5.02585 14.8626 5.03363 14.8626C5.04141 14.8626 5.0492 14.8626 5.05699 14.8626C5.06479 14.8626 5.07258 14.8626 5.08039 14.8626C5.08819 14.8626 5.096 14.8626 5.10381 14.8626C5.11162 14.8626 5.11944 14.8626 5.12726 14.8626C5.13508 14.8626 5.14291 14.8626 5.15074 14.8626C5.15857 14.8626 5.1664 14.8626 5.17424 14.8626C5.18208 14.8626 5.18993 14.8626 5.19777 14.8626C5.20562 14.8626 5.21348 14.8626 5.22133 14.8626C5.22919 14.8626 5.23705 14.8626 5.24492 14.8626C5.25279 14.8626 5.26066 14.8626 5.26853 14.8626C5.27641 14.8626 5.28429 14.8626 5.29217 14.8626C5.30005 14.8626 5.30794 14.8626 5.31583 14.8626C5.32372 14.8626 5.33162 14.8626 5.33952 14.8626C5.34742 14.8626 5.35532 14.8626 5.36323 14.8626C5.37113 14.8626 5.37905 14.8626 5.38696 14.8626C5.39488 14.8626 5.4028 14.8626 5.41072 14.8626C5.41864 14.8626 5.42657 14.8626 5.4345 14.8626C5.44243 14.8626 5.45036 14.8626 5.4583 14.8626C5.46624 14.8626 5.47418 14.8626 5.48212 14.8626C5.49007 14.8626 5.49802 14.8626 5.50597 14.8626C5.51392 14.8626 5.52188 14.8626 5.52984 14.8626C5.53779 14.8626 5.54576 14.8626 5.55372 14.8626C5.56169 14.8626 5.56966 14.8626 5.57763 14.8626C5.5856 14.8626 5.59358 14.8626 5.60156 14.8626C5.60953 14.8626 5.61752 14.8626 5.6255 14.8626C5.63349 14.8626 5.64147 14.8626 5.64947 14.8626C5.65746 14.8626 5.66545 14.8626 5.67345 14.8626C5.68145 14.8626 5.68945 14.8626 5.69745 14.8626C5.70545 14.8626 5.71346 14.8626 5.72147 14.8626C5.72948 14.8626 5.73749 14.8626 5.7455 14.8626C5.75352 14.8626 5.76153 14.8626 5.76955 14.8626C5.77757 14.8626 5.78559 14.8626 5.79362 14.8626C5.80164 14.8626 5.80967 14.8626 5.8177 14.8626C5.82573 14.8626 5.83377 14.8626 5.8418 14.8626C5.84984 14.8626 5.85787 14.8626 5.86591 14.8626C5.87395 14.8626 5.882 14.8626 5.89004 14.8626C5.89809 14.8626 5.90613 14.8626 5.91418 14.8626C5.92223 14.8626 5.93028 14.8626 5.93834 14.8626C5.94639 14.8626 5.95445 14.8626 5.9625 14.8626C5.97056 14.8626 5.97862 14.8626 5.98668 14.8626C5.99475 14.8626 6.00281 14.8626 6.01088 14.8626C6.01894 14.8626 6.02701 14.8626 6.03508 14.8626C6.04315 14.8626 6.05122 14.8626 6.0593 14.8626C6.06737 14.8626 6.07544 14.8626 6.08352 14.8626C6.0916 14.8626 6.09968 14.8626 6.10776 14.8626C6.11584 14.8626 6.12392 14.8626 6.132 14.8626C6.14009 14.8626 6.14817 14.8626 6.15626 14.8626C6.16435 14.8626 6.17243 14.8626 6.18052 14.8626C6.18861 14.8626 6.1967 14.8626 6.2048 14.8626C6.21289 14.8626 6.22098 14.8626 6.22908 14.8626C6.23717 14.8626 6.24527 14.8626 6.25337 14.8626C6.26146 14.8626 6.26956 14.8626 6.27766 14.8626C6.28576 14.8626 6.29386 14.8626 6.30197 14.8626C6.31007 14.8626 6.31817 14.8626 6.32627 14.8626C6.33438 14.8626 6.34248 14.8626 6.35059 14.8626C6.3587 14.8626 6.3668 14.8626 6.37491 14.8626C6.38302 14.8626 6.39113 14.8626 6.39924 14.8626C6.40735 14.8626 6.41546 14.8626 6.42357 14.8626C6.43168 14.8626 6.43979 14.8626 6.4479 14.8626C6.45601 14.8626 6.46413 14.8626 6.47224 14.8626C6.48035 14.8626 6.48847 14.8626 6.49658 14.8626C6.50469 14.8626 6.51281 14.8626 6.52092 14.8626C6.52904 14.8626 6.53715 14.8626 6.54527 14.8626C6.55339 14.8626 6.5615 14.8626 6.56962 14.8626C6.57774 14.8626 6.58585 14.8626 6.59397 14.8626C6.60209 14.8626 6.6102 14.8626 6.61832 14.8626C6.62644 14.8626 6.63455 14.8626 6.64267 14.8626C6.65079 14.8626 6.65891 14.8626 6.66702 14.8626C6.67514 14.8626 6.68326 14.8626 6.69138 14.8626C6.69949 14.8626 6.70761 14.8626 6.71573 14.8626C6.72384 14.8626 6.73196 14.8626 6.74008 14.8626C6.74819 14.8626 6.75631 14.8626 6.76442 14.8626C6.77254 14.8626 6.78065 14.8626 6.78877 14.8626C6.79688 14.8626 6.805 14.8626 6.81311 14.8626C6.82123 14.8626 6.82934 14.8626 6.83745 14.8626C6.84557 14.8626 6.85368 14.8626 6.86179 14.8626C6.8699 14.8626 6.87801 14.8626 6.88612 14.8626C6.89424 14.8626 6.90234 14.8626 6.91045 14.8626C6.91856 14.8626 6.92667 14.8626 6.93478 14.8626C6.94289 14.8626 6.95099 14.8626 6.9591 14.8626C6.9672 14.8626 6.97531 14.8626 6.98341 14.8626C6.99152 14.8626 6.99962 14.8626 7.00772 14.8626C7.01582 14.8626 7.02392 14.8626 7.03202 14.8626C7.04012 14.8626 7.04822 14.8626 7.05631 14.8626C7.06441 14.8626 7.07251 14.8626 7.0806 14.8626C7.0887 14.8626 7.09679 14.8626 7.10488 14.8626C7.11297 14.8626 7.12106 14.8626 7.12915 14.8626C7.13724 14.8626 7.14533 14.8626 7.15341 14.8626C7.1615 14.8626 7.16959 14.8626 7.17767 14.8626C7.18575 14.8626 7.19383 14.8626 7.20191 14.8626C7.20999 14.8626 7.21807 14.8626 7.22615 14.8626C7.23422 14.8626 7.2423 14.8626 7.25037 14.8626C7.25844 14.8626 7.26651 14.8626 7.27458 14.8626C7.28265 14.8626 7.29072 14.8626 7.29878 14.8626C7.30685 14.8626 7.31491 14.8626 7.32297 14.8626C7.33103 14.8626 7.33909 14.8626 7.34715 14.8626C7.35521 14.8626 7.36326 14.8626 7.37131 14.8626C7.37937 14.8626 7.38742 14.8626 7.39546 14.8626C7.40351 14.8626 7.41156 14.8626 7.4196 14.8626C7.42765 14.8626 7.43569 14.8626 7.44373 14.8626C7.45177 14.8626 7.4598 14.8626 7.46784 14.8626C7.47587 14.8626 7.4839 14.8626 7.49193 14.8626C7.49996 14.8626 7.50799 14.8626 7.51601 14.8626C7.52403 14.8626 7.53206 14.8626 7.54007 14.8626C7.54809 14.8626 7.55611 14.8626 7.56412 14.8626C7.57213 14.8626 7.58014 14.8626 7.58815 14.8626C7.59616 14.8626 7.60416 14.8626 7.61217 14.8626C7.62017 14.8626 7.62817 14.8626 7.63616 14.8626C7.64416 14.8626 7.65215 14.8626 7.66014 14.8626C7.66813 14.8626 7.67612 14.8626 7.6841 14.8626C7.69208 14.8626 7.70006 14.8626 7.70804 14.8626C7.71602 14.8626 7.72399 14.8626 7.73196 14.8626C7.73993 14.8626 7.7479 14.8626 7.75587 14.8626C7.76383 14.8626 7.77179 14.8626 7.77975 14.8626C7.7877 14.8626 7.79566 14.8626 7.80361 14.8626C7.81156 14.8626 7.81951 14.8626 7.82745 14.8626C7.83539 14.8626 7.84333 14.8626 7.85127 14.8626C7.8592 14.8626 7.86714 14.8626 7.87506 14.8626C7.88299 14.8626 7.89092 14.8626 7.89884 14.8626C7.90676 14.8626 7.91468 14.8626 7.92259 14.8626C7.9305 14.8626 7.93841 14.8626 7.94632 14.8626C7.95423 14.8626 7.96213 14.8626 7.97002 14.8626C7.97792 14.8626 7.98582 14.8626 7.9937 14.8626C8.00159 14.8626 8.00948 14.8626 8.01736 14.8626C8.02524 14.8626 8.03312 14.8626 8.04099 14.8626C8.04886 14.8626 8.05673 14.8626 8.0646 14.8626C8.07246 14.8626 8.08032 14.8626 8.08818 14.8626C8.09603 14.8626 8.10388 14.8626 8.11173 14.8626C8.11958 14.8626 8.12742 14.8626 8.13526 14.8626C8.1431 14.8626 8.15093 14.8626 8.15876 14.8626C8.16658 14.8626 8.17441 14.8626 8.18223 14.8626C8.19005 14.8626 8.19786 14.8626 8.20567 14.8626C8.21348 14.8626 8.22129 14.8626 8.22909 14.8626C8.23689 14.8626 8.24468 14.8626 8.25247 14.8626C8.26026 14.8626 8.26805 14.8626 8.27583 14.8626C8.28361 14.8626 8.29139 14.8626 8.29916 14.8626C8.30693 14.8626 8.31469 14.8626 8.32245 14.8626C8.33021 14.8626 8.33797 14.8626 8.34572 14.8626C8.35347 14.8626 8.36121 14.8626 8.36895 14.8626C8.37669 14.8626 8.38443 14.8626 8.39216 14.8626C8.39988 14.8626 8.40761 14.8626 8.41533 14.8626C8.42304 14.8626 8.43076 14.8626 8.43846 14.8626C8.44617 14.8626 8.45387 14.8626 8.46157 14.8626C8.46927 14.8626 8.47696 14.8626 8.48464 14.8626C8.49233 14.8626 8.50001 14.8626 8.50768 14.8626C8.51535 14.8626 8.52302 14.8626 8.53068 14.8626C8.53834 14.8626 8.546 14.8626 8.55365 14.8626C8.5613 14.8626 8.56895 14.8626 8.57659 14.8626C8.58422 14.8626 8.59186 14.8626 8.59948 14.8626C8.60711 14.8626 8.61473 14.8626 8.62235 14.8626C8.62996 14.8626 8.63757 14.8626 8.64517 14.8626C8.65277 14.8626 8.66037 14.8626 8.66796 14.8626C8.67555 14.8626 8.68313 14.8626 8.69071 14.8626C8.69829 14.8626 8.70586 14.8626 8.71342 14.8626C8.72099 14.8626 8.72855 14.8626 8.7361 14.8626C8.74365 14.8626 8.7512 14.8626 8.75874 14.8626C8.76627 14.8626 8.77381 14.8626 8.78133 14.8626C8.78886 14.8626 8.79638 14.8626 8.80389 14.8626C8.8114 14.8626 8.81891 14.8626 8.82641 14.8626C8.83391 14.8626 8.8414 14.8626 8.84888 14.8626C8.85637 14.8626 8.86385 14.8626 8.87132 14.8626C8.87879 14.8626 8.88626 14.8626 8.89372 14.8626C8.90117 14.8626 8.90862 14.8626 8.91607 14.8626C8.92351 14.8626 8.93095 14.8626 8.93838 14.8626C8.94581 14.8626 8.95323 14.8626 8.96065 14.8626C8.96806 14.8626 8.97547 14.8626 8.98287 14.8626C8.99027 14.8626 8.99767 14.8626 9.00505 14.8626C9.01244 14.8626 9.01982 14.8626 9.02719 14.8626C9.03456 14.8626 9.04193 14.8626 9.04928 14.8626C9.05664 14.8626 9.06399 14.8626 9.07133 14.8626C9.07867 14.8626 9.08601 14.8626 9.09333 14.8626C9.10066 14.8626 9.10798 14.8626 9.11529 14.8626C9.1226 14.8626 9.12991 14.8626 9.1372 14.8626C9.1445 14.8626 9.15179 14.8626 9.15907 14.8626C9.16635 14.8626 9.17362 14.8626 9.18088 14.8626C9.18815 14.8626 9.1954 14.8626 9.20265 14.8626C9.2099 14.8626 9.21714 14.8626 9.22437 14.8626C9.23161 14.8626 9.23883 14.8626 9.24605 14.8626C9.25326 14.8626 9.26047 14.8626 9.26767 14.8626C9.27487 14.8626 9.28206 14.8626 9.28924 14.8626C9.29643 14.8626 9.3036 14.8626 9.31077 14.8626C9.31794 14.8626 9.32509 14.8626 9.33224 14.8626C9.33939 14.8626 9.34654 14.8626 9.35367 14.8626C9.3608 14.8626 9.36793 14.8626 9.37504 14.8626C9.38216 14.8626 9.38926 14.8626 9.39636 14.8626C9.40346 14.8626 9.41055 14.8626 9.41763 14.8626C9.42471 14.8626 9.43179 14.8626 9.43885 14.8626C9.44591 14.8626 9.45297 14.8626 9.46001 14.8626C9.46706 14.8626 9.4741 14.8626 9.48112 14.8626C9.48815 14.8626 9.49517 14.8626 9.50218 14.8626C9.50919 14.8626 9.51619 14.8626 9.52318 14.8626C9.53018 14.8626 9.53716 14.8626 9.54413 14.8626C9.55111 14.8626 9.55807 14.8626 9.56503 14.8626C9.57198 14.8626 9.57893 14.8626 9.58586 14.8626C9.5928 14.8626 9.59973 14.8626 9.60665 14.8626C9.61356 14.8626 9.62047 14.8626 9.62737 14.8626C9.63427 14.8626 9.64116 14.8626 9.64804 14.8626C9.65492 14.8626 9.66179 14.8626 9.66865 14.8626C9.67551 14.8626 9.68236 14.8626 9.6892 14.8626C9.69605 14.8626 9.70288 14.8626 9.7097 14.8626C9.71652 14.8626 9.72333 14.8626 9.73014 14.8626C9.73694 14.8626 9.74373 14.8626 9.75051 14.8626C9.7573 14.8626 9.76407 14.8626 9.77083 14.8626C9.7776 14.8626 9.78435 14.8626 9.79109 14.8626C9.79783 14.8626 9.80457 14.8626 9.81129 14.8626C9.81801 14.8626 9.82472 14.8626 9.83143 14.8626C9.83813 14.8626 9.84482 14.8626 9.8515 14.8626C9.85818 14.8626 9.86486 14.8626 9.87152 14.8626C9.87818 14.8626 9.88483 14.8626 9.89147 14.8626C9.89811 14.8626 9.90474 14.8626 9.91136 14.8626C9.91798 14.8626 9.92459 14.8626 9.93118 14.8626C9.93778 14.8626 9.94437 14.8626 9.95095 14.8626C9.95753 14.8626 9.96409 14.8626 9.97065 14.8626C9.9772 14.8626 9.98375 14.8626 9.99028 14.8626C9.99682 14.8626 10.0033 14.8626 10.0099 14.8626C10.0164 14.8626 10.0229 14.8626 10.0294 14.8626C10.0358 14.8626 10.0423 14.8626 10.0488 14.8626C10.0553 14.8626 10.0617 14.8626 10.0682 14.8626C10.0746 14.8626 10.0811 14.8626 10.0875 14.8626C10.0939 14.8626 10.1003 14.8626 10.1067 14.8626C10.1131 14.8626 10.1195 14.8626 10.1259 14.8626C10.1323 14.8626 10.1386 14.8626 10.145 14.8626C10.1513 14.8626 10.1577 14.8626 10.164 14.8626C10.1704 14.8626 10.1767 14.8626 10.183 14.8626C10.1893 14.8626 10.1956 14.8626 10.2019 14.8626C10.2082 14.8626 10.2145 14.8626 10.2207 14.8626C10.227 14.8626 10.2332 14.8626 10.2395 14.8626C10.2457 14.8626 10.2519 14.8626 10.2582 14.8626C10.2644 14.8626 10.2706 14.8626 10.2768 14.8626C10.283 14.8626 10.2892 14.8626 10.2953 14.8626C10.3015 14.8626 10.3077 14.8626 10.3138 14.8626C10.3199 14.8626 10.3261 14.8626 10.3322 14.8626C10.3383 14.8626 10.3444 14.8626 10.3505 14.8626C10.3566 14.8626 10.3627 14.8626 10.3688 14.8626C10.3749 14.8626 10.3809 14.8626 10.387 14.8626C10.393 14.8626 10.3991 14.8626 10.4051 14.8626C10.4111 14.8626 10.4171 14.8626 10.4231 14.8626C10.4291 14.8626 10.4351 14.8626 10.4411 14.8626C10.447 14.8626 10.453 14.8626 10.4589 14.8626C10.4649 14.8626 10.4708 14.8626 10.4768 14.8626C10.4827 14.8626 10.4886 14.8626 10.4945 14.8626C10.5004 14.8626 10.5063 14.8626 10.5121 14.8626C10.518 14.8626 10.5239 14.8626 10.5297 14.8626C10.5356 14.8626 10.5414 14.8626 10.5472 14.8626C10.553 14.8626 10.5588 14.8626 10.5646 14.8626C10.5704 14.8626 10.5762 14.8626 10.582 14.8626C10.5877 14.8626 10.5935 14.8626 10.5992 14.8626C10.605 14.8626 10.6107 14.8626 10.6164 14.8626C10.6221 14.8626 10.6278 14.8626 10.6335 14.8626C10.6392 14.8626 10.6449 14.8626 10.6506 14.8626C10.6562 14.8626 10.6619 14.8626 10.6675 14.8626C10.6731 14.8626 10.6788 14.8626 10.6844 14.8626C10.69 14.8626 10.6956 14.8626 10.7011 14.8626C10.7067 14.8626 10.7123 14.8626 10.7178 14.8626C10.7234 14.8626 10.7289 14.8626 10.7345 14.8626C10.74 14.8626 10.7455 14.8626 10.751 14.8626C10.7565 14.8626 10.762 14.8626 10.7674 14.8626C10.7729 14.8626 10.7784 14.8626 10.7838 14.8626C10.7892 14.8626 10.7947 14.8626 10.8001 14.8626C10.8055 14.8626 10.8109 14.8626 10.8163 14.8626C10.8217 14.8626 10.827 14.8626 10.8324 14.8626C10.8378 14.8626 10.8431 14.8626 10.8484 14.8626C10.8538 14.8626 10.8591 14.8626 10.8644 14.8626C10.8697 14.8626 10.875 14.8626 10.8802 14.8626C10.8855 14.8626 10.8907 14.8626 10.896 14.8626C10.9012 14.8626 10.9065 14.8626 10.9117 14.8626C10.9169 14.8626 10.9221 14.8626 10.9273 14.8626C10.9324 14.8626 10.9376 14.8626 10.9428 14.8626C10.9479 14.8626 10.9531 14.8626 10.9582 14.8626C10.9633 14.8626 10.9684 14.8626 10.9735 14.8626C10.9786 14.8626 10.9837 14.8626 10.9887 14.8626C10.9938 14.8626 10.9989 14.8626 11.0039 14.8626C11.0089 14.8626 11.0139 14.8626 11.0189 14.8626C11.024 14.8626 11.0289 14.8626 11.0339 14.8626C11.0389 14.8626 11.0438 14.8626 11.0488 14.8626C11.0537 14.8626 11.0587 14.8626 11.0636 14.8626C11.0685 14.8626 11.0734 14.8626 11.0783 14.8626C11.0831 14.8626 11.088 14.8626 11.0929 14.8626C11.0977 14.8626 11.1025 14.8626 11.1074 14.8626C11.1122 14.8626 11.117 14.8626 11.1218 14.8626C11.1266 14.8626 11.1313 14.8626 11.1361 14.8626C11.1408 14.8626 11.1456 14.8626 11.1503 14.8626C11.155 14.8626 11.1597 14.8626 11.1644 14.8626C11.1691 14.8626 11.1738 14.8626 11.1785 14.8626C11.1831 14.8626 11.1878 14.8626 11.1924 14.8626C11.197 14.8626 11.2017 14.8626 11.2063 14.8626C11.2109 14.8626 11.2154 14.8626 11.22 14.8626C11.2246 14.8626 11.2291 14.8626 11.2336 14.8626C11.2382 14.8626 11.2427 14.8626 11.2472 14.8626C11.2517 14.8626 11.2562 14.8626 11.2606 14.8626C11.2651 14.8626 11.2696 14.8626 11.274 14.8626C11.2784 14.8626 11.2829 14.8626 11.2873 14.8626C11.2917 14.8626 11.296 14.8626 11.3004 14.8626C11.3048 14.8626 11.3091 14.8626 11.3135 14.8626C11.3178 14.8626 11.3221 14.8626 11.3264 14.8626C11.3307 14.8626 11.335 14.8626 11.3393 14.8626C11.3435 14.8626 11.3478 14.8626 11.352 14.8626C11.3563 14.8626 11.3605 14.8626 11.3647 14.8626C11.3689 14.8626 11.3731 14.8626 11.3772 14.8626C11.3814 14.8626 11.3856 14.8626 11.3897 14.8626C11.3938 14.8626 11.3979 14.8626 11.402 14.8626C11.4061 14.8626 11.4102 14.8626 11.4143 14.8626C11.4183 14.8626 11.4224 14.8626 11.4264 14.8626C11.4304 14.8626 11.4345 14.8626 11.4384 14.8626C11.4424 14.8626 11.4464 14.8626 11.4504 14.8626C11.4543 14.8626 11.4583 14.8626 11.4622 14.8626C11.4661 14.8626 11.47 14.8626 11.4739 14.8626C11.4778 14.8626 11.4817 14.8626 11.4855 14.8626C11.4894 14.8626 11.4932 14.8626 11.497 14.8626C11.5009 14.8626 11.5047 14.8626 11.5084 14.8626C11.5122 14.8626 11.516 14.8626 11.5197 14.8626C11.5235 14.8626 11.5272 14.8626 11.5309 14.8626C11.5346 14.8626 11.5383 14.8626 11.542 14.8626C11.5457 14.8626 11.5493 14.8626 11.553 14.8626C11.5566 14.8626 11.5602 14.8626 11.5638 14.8626C11.5674 14.8626 11.571 14.8626 11.5746 14.8626C11.5781 14.8626 11.5817 14.8626 11.5852 14.8626C11.5887 14.8626 11.5923 14.8626 11.5957 14.8626C11.5992 14.8626 11.6027 14.8626 11.6062 14.8626C11.6096 14.8626 11.6131 14.8626 11.6165 14.8626C11.6199 14.8626 11.6233 14.8626 11.6267 14.8626C11.6301 14.8626 11.6334 14.8626 11.6368 14.8626C11.6401 14.8626 11.6434 14.8626 11.6467 14.8626C11.65 14.8626 11.6533 14.8626 11.6566 14.8626C11.6599 14.8626 11.6631 14.8626 11.6663 14.8626C11.6696 14.8626 11.6728 14.8626 11.676 14.8626C11.6792 14.8626 11.6823 14.8626 11.6855 14.8626C11.6886 14.8626 11.6918 14.8626 11.6949 14.8626C11.698 14.8626 11.7011 14.8626 11.7042 14.8626C11.7073 14.8626 11.7103 14.8626 11.7134 14.8626C11.7164 14.8626 11.7194 14.8626 11.7224 14.8626C11.7254 14.8626 11.7284 14.8626 11.7313 14.8626C11.7343 14.8626 11.7372 14.8626 11.7402 14.8626C11.7431 14.8626 11.746 14.8626 11.7489 14.8626C11.7518 14.8626 11.7546 14.8626 11.7575 14.8626C11.7603 14.8626 11.7631 14.8626 11.7659 14.8626C11.7687 14.8626 11.7715 14.8626 11.7743 14.8626C11.777 14.8626 11.7798 14.8626 11.7825 14.8626C11.7852 14.8626 11.7879 14.8626 11.7906 14.8626C11.7933 14.8626 11.796 14.8626 11.7986 14.8626C11.8013 14.8626 11.8039 14.8626 11.8065 14.8626C11.8091 14.8626 11.8117 14.8626 11.8142 14.8626C11.8168 14.8626 11.8194 14.8626 11.8219 14.8626C11.8244 14.8626 11.8269 14.8626 11.8294 14.8626C11.8319 14.8626 11.8343 14.8626 11.8368 14.8626C11.8392 14.8626 11.8416 14.8626 11.844 14.8626C11.8464 14.8626 11.8488 14.8626 11.8512 14.8626C11.8535 14.8626 11.8559 14.8626 11.8582 14.8626C11.8605 14.8626 11.8628 14.8626 11.8651 14.8626C11.8674 14.8626 11.8696 14.8626 11.8718 14.8626C11.8741 14.8626 11.8763 14.8626 11.8785 14.8626C11.8807 14.8626 11.8829 14.8626 11.885 14.8626C11.8872 14.8626 11.8893 14.8626 11.8914 14.8626C11.8935 14.8626 11.8956 14.8626 11.8977 14.8626C11.8997 14.8626 11.9018 14.8626 11.9038 14.8626C11.9058 14.8626 11.9078 14.8626 11.9098 14.8626C11.9118 14.8626 11.9138 14.8626 11.9157 14.8626C11.9176 14.8626 11.9196 14.8626 11.9215 14.8626C11.9234 14.8626 11.9252 14.8626 11.9271 14.8626C11.9289 14.8626 11.9308 14.8626 11.9326 14.8626C11.9344 14.8626 11.9362 14.8626 11.938 14.8626C11.9397 14.8626 11.9415 14.8626 11.9432 14.8626C11.9449 14.8626 11.9466 14.8626 11.9483 14.8626C11.95 14.8626 11.9516 14.8626 11.9533 14.8626C11.9549 14.8626 11.9565 14.8626 11.9581 14.8626C11.9597 14.8626 11.9613 14.8626 11.9628 14.8626C11.9644 14.8626 11.9659 14.8626 11.9674 14.8626C11.9689 14.8626 11.9704 14.8626 11.9719 14.8626C11.9733 14.8626 11.9748 14.8626 11.9762 14.8626C11.9776 14.8626 11.979 14.8626 11.9804 14.8626C11.9818 14.8626 11.9831 14.8626 11.9844 14.8626C11.9858 14.8626 11.9871 14.8626 11.9884 14.8626V13.8626ZM0.762146 13.3626C0.762146 14.1888 1.42799 14.8626 2.25868 14.8626V13.8626C1.9848 13.8626 1.76215 13.641 1.76215 13.3626H0.762146Z"
                            fill="#222222"
                          />
                        </svg>
                      </span>
                      <span className="text">Contact</span>
                    </div>
                    <a
                      onClick={(e) => this.handleCreateContact("contact")}
                      className={`${this.props.classes.tabButton} link  convert-link`}
                    >
                      <CustomIcons iconName="add" /> Create
                    </a>
                  </div>
                  <div className="fieldblock">
                    <SearchSelectBox
                      {...this.props}
                      id="select-pagesize"
                      required
                      // readOnly
                      name="ContactId"
                      placeholder="Search and select an existing Contact"
                      fullWidth
                      // async
                      getData={this.fetchContacts.bind(this)}
                      value={
                        ContactDatas.ContactName ? ContactDatas.ContactName : ""
                      }
                      onChange={this.handleContactAutoChange}
                      error={
                        errors.ContactId !== "" &&
                        errors.ContactId !== undefined
                      }
                      margin="normal"
                      Data={Contacts}
                    />
                  </div>
                </div>
                <div
                  onClick={(e) => this.toggleActiveItem("opportunity")}
                  className={
                    activeItem === "opportunity"
                      ? `${this.props.classes.groupActive} item active`
                      : "item"
                  }
                >
                  <div className="flex-details">
                    <div className="name">
                      <span className="icon">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M4.41155 0.0302499C2.18905 0.203165 0.368508 1.19356 0.0541503 2.40078C-0.0180501 2.67814 -0.0180501 11.4644 0.0541503 11.7418C0.476262 13.3628 3.62059 14.4953 6.48914 14.0596L6.77032 14.0169L6.8474 14.1146C8.44487 16.1388 11.5215 16.6075 13.6904 15.1571C16.7699 13.098 16.7699 8.60148 13.6904 6.54791C12.8713 6.00166 12.0163 5.73746 10.9646 5.70571L10.3788 5.68802V4.13609C10.3788 2.41181 10.3773 2.39634 10.1712 2.00407C9.46776 0.665002 7.02282 -0.172886 4.41155 0.0302499ZM6.21496 1.0099C8.3208 1.2385 9.7859 2.25555 9.33561 3.1762C8.44334 5.00054 2.92527 5.20877 1.27709 3.48031C0.000538928 2.14158 2.96722 0.657346 6.21496 1.0099ZM1.31874 4.70915C3.44014 5.97775 7.27441 5.93666 9.23064 4.6244L9.44152 4.48295V5.1794V5.87587L9.15491 5.976C8.45249 6.22136 7.81015 6.61922 7.25458 7.15313L7.02026 7.37829L6.62973 7.4433C4.53948 7.79128 2.19111 7.31401 1.27709 6.35546C0.975542 6.03922 0.960983 5.9865 0.949299 5.16746L0.93927 4.46686L1.01178 4.51789C1.05165 4.54599 1.18977 4.63206 1.31874 4.70915ZM11.6485 6.7241C14.5762 7.29438 15.9995 10.6759 14.3599 13.1655C12.5803 15.8676 8.48508 15.6134 7.08231 12.7138C5.77745 10.0165 7.47327 7.01218 10.5038 6.65238C10.7226 6.62638 11.3479 6.66557 11.6485 6.7241ZM1.31874 7.5843C2.40368 8.23309 3.81304 8.54023 5.52626 8.50126C5.92697 8.49213 6.25483 8.49051 6.25483 8.49766C6.25483 8.50479 6.2119 8.59573 6.15942 8.69971C5.97296 9.06916 5.72371 9.95809 5.72371 10.2535C5.72371 10.6114 3.22494 10.268 2.145 9.76173C1.17471 9.3069 0.964076 8.9986 0.949205 8.01133L0.939114 7.34189L1.01169 7.39298C1.05162 7.42111 1.18977 7.50721 1.31874 7.5843ZM10.3788 8.0708V8.57029L10.2164 8.65258C9.34214 9.09576 9.17621 10.2641 9.89144 10.9408C10.1495 11.1849 10.3869 11.2799 10.8878 11.3392C11.2878 11.3866 11.4455 11.8652 11.1474 12.127C10.8925 12.351 10.4958 12.2339 10.4083 11.909L10.3764 11.7903H9.90893H9.44152L9.4419 11.8918C9.44343 12.3152 9.79203 12.8377 10.2164 13.0529L10.3788 13.1352V13.6347V14.1341H10.8474H11.316V13.6347V13.1352L11.4775 13.0533C12.6719 12.4479 12.391 10.5681 11.0813 10.4014C10.9956 10.3905 10.8652 10.3741 10.7914 10.365C10.4206 10.3192 10.2641 9.86917 10.5245 9.59729C10.7665 9.34465 11.2245 9.47565 11.2999 9.81911L11.321 9.91518H11.7916H12.2622L12.2419 9.72089C12.1997 9.31721 11.8876 8.8724 11.5023 8.66699L11.316 8.5677V8.06949V7.5713H10.8474H10.3788V8.0708ZM1.31874 10.397C2.05221 10.8356 2.89671 11.1025 4.05592 11.2622C4.19138 11.2808 4.61777 11.3053 5.00352 11.3166L5.70481 11.3371L5.74343 11.605C5.81119 12.0752 5.97921 12.6468 6.14867 12.9832L6.22218 13.1293L6.01202 13.1544C4.28673 13.3611 2.06917 12.8114 1.27709 11.9808C0.97776 11.6669 0.961014 11.6077 0.949205 10.824L0.939114 10.1545L1.01169 10.2056C1.05162 10.2338 1.18977 10.3199 1.31874 10.397Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      <span className="text">Opportunity</span>
                    </div>
                    <a
                      onClick={(e) =>
                        this.handleCreateOpportunity("opportunity")
                      }
                      className={`${this.props.classes.tabButton} link  convert-link`}
                    >
                      <CustomIcons iconName="add" /> Create
                    </a>
                  </div>
                  <div className="fieldblock">
                    <SearchSelectBox
                      {...this.props}
                      id="select-pagesize"
                      required
                      // readOnly
                      name="OpportunityId"
                      placeholder="Search and select an existing Opportunity"
                      // async
                      fullWidth
                      getData={this.fetchOpportunity.bind(this)}
                      value={
                        OpportunityDatas.OpportunityName
                          ? OpportunityDatas.OpportunityName
                          : ""
                      }
                      onChange={this.handleOpportunityAutoChange}
                      error={
                        errors.OpportunityId !== "" &&
                        errors.OpportunityId !== undefined
                      }
                      margin="normal"
                      Data={Opertunities}
                    />
                  </div>
                </div>
              </div>

              <div className="convert-details">
                {this.state.activeItem === "" ? (
                  <LeadConvertEmpty
                    ref={this.child}
                    fetchValuesFromChild={this.fetchValuesFromChild}
                    fieldData={this.state.fieldData}
                    leadData={this.state.leadData}
                    {...this.props}
                  />
                ) : (
                  <>
                    {this.state.activeItem === "account" && (
                      <>
                        {AccountDatas.AccountId === "" ||
                          AccountDatas.AccountId === null ||
                          AccountDatas.AccountId === undefined ? (
                          <>
                            {accountCreate ? (
                              <LeadConvertCreate
                                {...this.props}
                                ref={this.child}
                                fetchValuesFromChild={this.fetchValuesFromChild}
                                title={"Create Account"}
                                masterkey={"account"}
                                isActive={this.state.isActive}
                                fieldData={this.state.fieldData}
                                leadData={this.state.leadData}
                                mappingData={this.state.mappingData.account}
                              />
                            ) : (
                              <LeadConvertEmpty
                                ref={this.child}
                                fetchValuesFromChild={this.fetchValuesFromChild}
                                fieldData={this.state.fieldData}
                                leadData={this.state.leadData}
                                {...this.props}
                              />
                            )}
                          </>
                        ) : (
                          <LeadConvertSelect
                            ref={this.child}
                            fetchValuesFromChild={this.fetchValuesFromChild}
                            masterKey={"account"}
                            type={this.state.activeItem}
                            fieldData={this.state.fieldData}
                            isActive={this.state.isActive}
                            leadData={this.state.leadData}
                            {...this.props}
                            mappingData={this.state.mappingData.account}
                          />
                        )}
                      </>
                    )}
                    {this.state.activeItem === "contact" && (
                      <>
                        {ContactDatas.ContactId === "" ||
                          ContactDatas.ContactId === null ||
                          ContactDatas.ContactId === undefined ? (
                          <>
                            {contactCreate ? (
                              <LeadConvertCreate
                                ref={this.child}
                                {...this.props}
                                fetchValuesFromChild={this.fetchValuesFromChild}
                                title={"Create Contact"}
                                masterkey={"contact"}
                                isActive={this.state.isActive}
                                fieldData={this.state.fieldData}
                                leadData={this.state.leadData}
                                mappingData={this.state.mappingData.contact}
                              />
                            ) : (
                              <LeadConvertEmpty
                                ref={this.child}
                                fetchValuesFromChild={this.fetchValuesFromChild}
                                fieldData={this.state.fieldData}
                                leadData={this.state.leadData}
                                {...this.props}
                              />
                            )}
                          </>
                        ) : (
                          <LeadConvertSelect
                            masterKey={"contact"}
                            ref={this.child}
                            fetchValuesFromChild={this.fetchValuesFromChild}
                            type={this.state.activeItem}
                            fieldData={this.state.fieldData}
                            isActive={this.state.isActive}
                            leadData={this.state.leadData}
                            {...this.props}
                            mappingData={this.state.mappingData.contact}
                          />
                        )}
                      </>
                    )}
                    {this.state.activeItem === "opportunity" && (
                      <>
                        {OpportunityDatas.OpportunityId === "" ||
                          OpportunityDatas.OpportunityId === null ||
                          OpportunityDatas.OpportunityId === undefined ? (
                          <>
                            {opportunityCreate ? (
                              <LeadConvertCreate
                                {...this.props}
                                ref={this.child}
                                fetchValuesFromChild={this.fetchValuesFromChild}
                                fieldData={this.state.fieldData}
                                leadData={this.state.leadData}
                                isActive={this.state.isActive}
                                title={"Create Opportunity"}
                                masterkey={"opportunity"}
                                mappingData={this.state.mappingData.opportunity}
                              />
                            ) : (
                              <LeadConvertEmpty
                                ref={this.child}
                                fetchValuesFromChild={this.fetchValuesFromChild}
                                fieldData={this.state.fieldData}
                                leadData={this.state.leadData}
                                {...this.props}
                              />
                            )}
                          </>
                        ) : (
                          <LeadConvertSelect
                            ref={this.child}
                            masterKey={"opportunity"}
                            fetchValuesFromChild={this.fetchValuesFromChild}
                            type={this.state.activeItem}
                            fieldData={this.state.fieldData}
                            isActive={this.state.isActive}
                            leadData={this.state.leadData}
                            {...this.props}
                            mappingData={this.state.mappingData.opportunity}
                          />
                        )}
                      </>
                    )}
                  </>
                )}
                {/* <LeadConvertEmpty {...props} /> */}
                {/* <LeadConvertCreate {...props} /> */}
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <ButtonSml
              {...this.props}
              type="button"
              onClick={this.handleClose}
              className={`${this.props.classes.secondaryBtn} btn btn-secondary`}
              label="Cancel"
            />
            <ButtonSml
              {...this.props}
              disabled={this.state.submit}
              onClick={this.fetchData}
              className={`${this.props.classes.primaryBtn} btn btn-primary`}
              label="Convert"
            />
          </DialogActions>
        </Dialog>
      </>
    );
  }
}
